<template>
  <div class="chat-wrapper">
    <v-container v-if="showChat" fluid class="pa-0 fill-height d-flex">
      <!-- Sidebar -->
      <div
        v-show="sidebar"
        class="fancy-drawer-light elevation-8 custom-scrollbar"
        style="width: 320px; height: calc(100vh - 80px); position: fixed; left: 0; top: 66px; overflow-y: auto; overflow-x: hidden; z-index: 2000;"
      >
        <!-- Header -->
        <v-toolbar flat dense class="drawer-header-light">
          <v-toolbar-title class="font-weight-bold text-primary">💬 Messages</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closewindow" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- Sub-header -->
        <v-card flat class="pa-3 sub-header-light">
          <p class="caption">✨ Connect & Chat with friends</p>
        </v-card>
        <!-- Tabs -->
        <v-tabs v-model="activeTab" grow class="mx-3 mt-2">
          <v-tab>
            <v-icon small class="mr-1">mdi-account</v-icon>
            All
          </v-tab>
          <v-tab>
            <v-icon small class="mr-1">mdi-account-group</v-icon>
            Groups
          </v-tab>
        </v-tabs>

        <!-- Search -->
        <v-text-field
          v-model="searchQuery"
          append-icon="mdi-magnify"
          :placeholder="activeTab === 0 ? 'Search users...' : 'Search groups...'"
          dense
          rounded
          outlined
          hide-details
          class="mx-3 mt-2 search-bar"
          @input="activeTab === 0 ? searchUsers() : searchGroups()"
        ></v-text-field>
        <!-- Loader -->
        <v-progress-linear
          v-if="loader_check"
          indeterminate
          color="deep-purple lighten-2"
          class="mx-3 mt-2"
          rounded
        ></v-progress-linear>

        <!-- Tab Content -->
        <v-tabs-items v-model="activeTab">
          <!-- All Users Tab -->
          <v-tab-item>
            <v-list dense class="conversation-list">
          <v-list-item
            v-for="user in usersList"
            :key="user.id"
            @click="selectConversation(user)"
            class="conversation-item-light"
          >
            <!-- Avatar -->
            <v-list-item-avatar size="44" class="avatar-gradient" style="cursor: pointer;"
              @click.stop="openImageViewer(getProfilePicUrl(user.profile_pic), user.user_name)">
              <img
                v-if="getProfilePicUrl(user.profile_pic)"
                :src="getProfilePicUrl(user.profile_pic)"
                :alt="user.user_name"
                style="width:100%;height:100%;object-fit:cover;border-radius:50%;"
              />
              <span v-else class="white--text font-weight-bold">
                {{ (user.user_name ? user.user_name[0] : "?").toUpperCase() }}
              </span>
            </v-list-item-avatar>

            <!-- Name + last message -->
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium text-primary">
                {{ user.user_name }}
              </v-list-item-title>
              <v-list-item-subtitle class="grey--text text-truncate">
                <template v-if="user.lastMessage && user.lastMessage.text">
                  <v-icon
                    v-if="user.lastMessage.is_me"
                    x-small
                    :color="user.lastMessage.status === 'read' ? 'blue' : 'grey'"
                    class="mr-1"
                  >
                    {{
                      user.lastMessage.status === 'sent'
                        ? 'mdi-check'
                        : user.lastMessage.status === 'delivered'
                          ? 'mdi-check-all'
                          : user.lastMessage.status === 'read'
                            ? 'mdi-check-all'
                            : 'mdi-check'
                    }}
                  </v-icon>
                  <span>{{ user.lastMessage.text }}</span>
                </template>
                <span v-else style="opacity: 0.5; font-style: italic;">
                  Tap to start chatting
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>

            <!-- Time + unread badge -->
            <v-list-item-action class="d-flex flex-column align-end">
              <span v-if="user.lastMessage && user.lastMessage.timestamp" class="caption grey--text" style="white-space: nowrap;">
                {{ formatSidebarTime(user.lastMessage.timestamp) }}
              </span>
              <v-badge
                v-if="user.unreadCount > 0"
                :content="user.unreadCount"
                color="green accent-4"
                class="mt-1"
              ></v-badge>
            </v-list-item-action>
          </v-list-item>
        </v-list>
          </v-tab-item>

          <!-- Groups Tab -->
          <v-tab-item>
            <!-- Create Group Button -->
            <div class="px-3 py-2">
              <v-btn
                block
                color="primary"
                @click="openCreateGroupDialog"
                class="text-capitalize"
              >
                <v-icon left>mdi-plus-circle</v-icon>
                Create New Group
              </v-btn>
            </div>

            <v-list dense class="conversation-list">
              <v-list-item
                v-for="group in groupsList"
                :key="group.id"
                @click="selectGroup(group)"
                class="conversation-item-light"
              >
                <!-- Group Avatar -->
                <v-list-item-avatar size="44" class="avatar-gradient-group" style="cursor: pointer;"
                  @click.stop="openImageViewer(group.group_pic, group.group_name)">
                  <img v-if="group.group_pic" :src="group.group_pic" :alt="group.group_name" style="width:100%;height:100%;object-fit:cover;border-radius:50%;" />
                  <v-icon v-else color="white">mdi-account-group</v-icon>
                </v-list-item-avatar>

                <!-- Group Name + last message -->
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-primary">
                    {{ group.group_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="grey--text text-truncate">
                    <template v-if="group.lastMessage && group.lastMessage.text">
                      <v-icon
                        v-if="group.lastMessage.is_me"
                        x-small
                        :color="group.lastMessage.status === 'read' ? 'blue' : 'grey'"
                        class="mr-1"
                      >
                        {{
                          group.lastMessage.status === 'sent'
                            ? 'mdi-check'
                            : group.lastMessage.status === 'delivered'
                              ? 'mdi-check-all'
                              : group.lastMessage.status === 'read'
                                ? 'mdi-check-all'
                                : 'mdi-check'
                        }}
                      </v-icon>
                      <span>{{ group.lastMessage.text }}</span>
                    </template>
                    <span v-else style="opacity: 0.5; font-style: italic;">
                      {{ group.memberCount }} {{ group.memberCount === 1 ? 'Member' : 'Members' }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <!-- Time + unread badge -->
                <v-list-item-action class="d-flex flex-column align-end">
                  <span v-if="group.lastMessage && group.lastMessage.timestamp" class="caption grey--text" style="white-space: nowrap;">
                    {{ formatSidebarTime(group.lastMessage.timestamp) }}
                  </span>
                  <v-badge
                    v-if="group.unreadCount > 0"
                    :content="group.unreadCount"
                    color="green accent-4"
                    class="mt-1"
                  ></v-badge>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <!-- Chat Area -->
      <v-card class="chat-area flex-grow-1 d-flex flex-column">
        <div class="chat-container-wrapper">
          <div v-if="activeConversation" class="chat-container d-flex flex-column flex-grow-1">

            <!-- Header (Fixed at top) -->
            <div class="chat-header">
              <div class="header-left">
                <!-- Show group icon for groups, user avatar for 1-on-1 -->
                <v-menu v-if="activeConversation.isGroup" offset-y nudge-bottom="4">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="avatar group-avatar" style="cursor: pointer;" v-bind="attrs" v-on="on">
                      <img
                        v-if="activeConversation.group_pic"
                        :src="activeConversation.group_pic"
                        :alt="activeConversation.user_name"
                        style="width:100%;height:100%;object-fit:cover;border-radius:50%;"
                      />
                      <v-icon v-else color="white" small>mdi-account-group</v-icon>
                    </div>
                  </template>
                  <v-list dense>
                    <v-list-item @click="openImageViewer(activeConversation.group_pic, activeConversation.user_name)">
                      <v-list-item-icon class="mr-2"><v-icon small>mdi-eye</v-icon></v-list-item-icon>
                      <v-list-item-title>View Group Picture</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$refs.groupPicInput.click()">
                      <v-list-item-icon class="mr-2"><v-icon small>mdi-camera</v-icon></v-list-item-icon>
                      <v-list-item-title>Change Group Picture</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <div v-else class="avatar" style="cursor: pointer;"
                     @click="openImageViewer(getProfilePicUrl(activeConversation.profile_pic), activeConversation.user_name)">
                  <img
                    v-if="getProfilePicUrl(activeConversation.profile_pic)"
                    :src="getProfilePicUrl(activeConversation.profile_pic)"
                    :alt="activeConversation.user_name"
                    style="width:100%;height:100%;object-fit:cover;border-radius:50%;"
                  />
                  <span v-else>{{ (activeConversation.user_name ? activeConversation.user_name[0] : "?").toUpperCase() }}</span>
                </div>
                <!-- Hidden file input for group pic upload -->
                <input
                  ref="groupPicInput"
                  type="file"
                  accept="image/*"
                  style="display: none;"
                  @change="uploadGroupPic"
                />
                <div>
                  <div class="user-name">{{ activeConversation.user_name || "Unknown" }}</div>
                  <!-- Show Family Office member count for groups - clickable -->
                  <div v-if="activeConversation.isGroup"
                       class="caption white--text member-count-clickable"
                       style="opacity: 0.8; cursor: pointer;"
                       @click="showGroupMembers">
                    {{ activeConversation.memberCount || getGroupMemberCount(activeConversation.id) }} members
                  </div>
                </div>
              </div>

              <div class="header-right">
                <div class="user-status">
                  <!-- Don't show online status for groups -->
                  <span v-if="!activeConversation.isGroup">
                    {{ isOtherUserTyping ? "✍️ Typing..." : (otherUserOnline ? "🟢 Online" : "⚪ Offline") }}
                  </span>
                  <span v-else-if="isOtherUserTyping">✍️ Someone is typing...</span>
                </div>
                <button class="close-btn" @click="closeChat">✖</button>
              </div>
            </div>



            <!-- Messages (Scrollable middle area) -->
            <v-card-text class="messages-area flex-grow-1 pa-3" ref="messagesArea">
              <div v-for="msg in messages[activeConversation.id] || []" :key="msg.id" class="d-flex flex-column mb-2 message-wrapper">
                <!-- System message (group actions) -->
                <div v-if="msg.is_system" class="system-message-wrapper">
                  <div class="system-message">
                    <v-icon x-small class="mr-1" :color="msg.systemColor || '#6c757d'">{{ msg.systemIcon || 'mdi-information' }}</v-icon>
                    {{ msg.text }}
                  </div>
                </div>
                <template v-else>
                  <!-- Sender name + avatar (group chats only, for messages from others) -->
                  <div
                    v-if="activeConversation.isGroup && msg.from !== 'me' && msg.sender_name"
                    class="group-sender-row align-self-start"
                  >
                    <img
                      v-if="msg.sender_profile_pic"
                      :src="msg.sender_profile_pic"
                      :alt="msg.sender_name"
                      class="group-msg-avatar"
                    />
                    <span v-else class="group-msg-avatar-initial">
                      {{ msg.sender_name ? msg.sender_name[0].toUpperCase() : '?' }}
                    </span>
                    <span class="group-sender-name">{{ msg.sender_name }}</span>
                  </div>

                  <span class="chat-bubble" :class="msg.from === 'me' ? 'sender' : 'receiver'">
                    <!-- Delete button (only for own messages) -->
                    <v-btn v-if="msg.from === 'me'" icon x-small class="delete-message-btn" @click="deleteMessage(msg)">
                      <v-icon x-small color="grey">mdi-delete</v-icon>
                    </v-btn>

                    <!-- Voice message -->
                    <div v-if="msg.is_voice" class="voice-message d-flex align-center">
                      <v-btn icon small @click="playVoiceMessage(msg)">
                        <v-icon :color="msg.from === 'me' ? 'white' : '#4e342e'">
                          {{ currentlyPlayingId === msg.id ? 'mdi-pause-circle' : 'mdi-play-circle' }}
                        </v-icon>
                      </v-btn>
                      <div class="voice-waveform ml-2 mr-2" :class="{ 'playing': currentlyPlayingId === msg.id }"></div>
                      <span class="caption">{{ formatDuration(msg.duration) }}</span>
                    </div>

                    <!-- File attachment -->
                    <div v-else-if="msg.is_file" class="file-attachment">
                      <!-- Image -->
                      <div v-if="msg.file_type && msg.file_type.startsWith('image/')" class="image-attachment">
                        <img :src="msg.file_data" :alt="msg.file_name" class="attachment-image" @click="openImageFullScreen(msg.file_data)"/>
                        <div class="file-name caption mt-1">{{ msg.file_name }}</div>
                      </div>

                      <!-- Video -->
                      <div v-else-if="msg.file_type && msg.file_type.startsWith('video/')" class="video-attachment">
                        <video controls class="attachment-video">
                          <source :src="msg.file_data" :type="msg.file_type">
                        </video>
                        <div class="file-name caption mt-1">{{ msg.file_name }}</div>
                      </div>

                      <!-- Document/Other files -->
                      <div v-else class="document-attachment d-flex align-center pa-2">
                        <v-icon large :color="msg.from === 'me' ? 'white' : 'primary'">
                          {{ getFileIcon(msg.file_name) }}
                        </v-icon>
                        <div class="ml-3 flex-grow-1">
                          <div class="file-name font-weight-medium">{{ msg.file_name }}</div>
                          <div class="caption">{{ formatFileSize(msg.file_size) }}</div>
                        </div>
                        <v-btn icon small @click="downloadFile(msg)">
                          <v-icon :color="msg.from === 'me' ? 'white' : 'primary'">mdi-download</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <!-- Text message -->
                    <span v-else v-html="linkifyText(msg.text)"></span>

                    <v-icon small v-if="msg.from === 'me'" class="ml-1"
                      :color="msg.status === 'read' ? 'blue lighten-2' : 'white'">
                      {{ msg.status === 'sent' ? 'mdi-check' : 'mdi-check-all' }}
                    </v-icon>
                  </span>

                  <small class="grey--text mt-1 message-timestamp" :class="msg.from === 'me' ? 'align-self-end' : 'align-self-start'" style="font-size: 11px; display: block;">
                    {{ formatMessageTime(msg.timestamp || msg.time) }}
                  </small>

                  <!-- Seen by (group chats only, for my own messages) -->
                  <div
                    v-if="activeConversation.isGroup && msg.from === 'me' && msg.seen_by && msg.seen_by.length > 0"
                    class="seen-by-row align-self-end"
                  >
                    <v-icon x-small color="blue">mdi-eye</v-icon>
                    <span class="seen-by-names">{{ msg.seen_by.map(s => s.name).join(', ') }}</span>
                  </div>
                </template>
              </div>
            </v-card-text>

            <!-- Input area (Fixed at bottom) -->
            <v-card-actions class="chat-input-area">
              <!-- Recording indicator -->
              <div v-if="isRecording" class="recording-indicator d-flex align-center flex-grow-1">
                <v-icon color="red" class="recording-pulse">mdi-microphone</v-icon>
                <span class="ml-2 red--text font-weight-bold">{{ formatRecordingTime() }}</span>
                <v-spacer></v-spacer>
                <v-btn icon small @click="cancelVoiceRecording" class="ml-2">
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
                <v-btn icon class="send-btn ml-2" @click="stopVoiceRecording">
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </div>

              <!-- Normal input mode -->
              <template v-else>
                <!-- Attachment Menu -->
                <v-menu offset-y top transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon color="primary">mdi-plus-circle</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="attachment-menu elevation-8">
                    <v-list dense class="pa-0">
                      <v-list-item @click="openGallery" class="attachment-item">
                        <v-list-item-avatar class="attachment-icon" style="background: linear-gradient(135deg, #667eea, #764ba2);">
                          <v-icon color="white">mdi-image-multiple</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">Gallery</v-list-item-title>
                          <v-list-item-subtitle class="caption">Photos & Videos</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item @click="openDocuments" class="attachment-item">
                        <v-list-item-avatar class="attachment-icon" style="background: linear-gradient(135deg, #f093fb, #f5576c);">
                          <v-icon color="white">mdi-file-document</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">Document</v-list-item-title>
                          <v-list-item-subtitle class="caption">All Files</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>

                <!-- Hidden file inputs -->
                <input
                  ref="galleryInput"
                  type="file"
                  accept="image/*,video/*"
                  multiple
                  style="display: none"
                  @change="handleGalleryUpload"
                />
                <input
                  ref="documentInput"
                  type="file"
                  multiple
                  style="display: none"
                  @change="handleDocumentUpload"
                />

                <!-- File Preview Area (shows when file is selected) -->
                <div v-if="pendingFiles.length > 0" class="file-preview-container d-flex flex-column flex-grow-1">
                  <div class="file-preview-list d-flex flex-wrap pa-2">
                    <div v-for="(file, index) in pendingFilesPreview" :key="index" class="file-preview-item ma-1">
                      <!-- Image Preview -->
                      <div v-if="file.type.startsWith('image/')" class="preview-image-wrapper">
                        <img :src="file.preview" :alt="file.name" class="preview-image"/>
                        <v-btn icon x-small class="remove-file-btn" @click="removePendingFile(index)">
                          <v-icon small color="white">mdi-close</v-icon>
                        </v-btn>
                      </div>
                      <!-- Video Preview -->
                      <div v-else-if="file.type.startsWith('video/')" class="preview-video-wrapper">
                        <video class="preview-video">
                          <source :src="file.preview" :type="file.type">
                        </video>
                        <v-btn icon x-small class="remove-file-btn" @click="removePendingFile(index)">
                          <v-icon small color="white">mdi-close</v-icon>
                        </v-btn>
                      </div>
                      <!-- Document Preview -->
                      <div v-else class="preview-document">
                        <v-icon large>{{ getFileIcon(file.name) }}</v-icon>
                        <div class="caption text-truncate" style="max-width: 80px;">{{ file.name }}</div>
                        <v-btn icon x-small class="remove-file-btn" @click="removePendingFile(index)">
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-center pa-2">
                    <v-text-field v-model="newMessage" placeholder="Add a caption (optional)..." outlined dense
                      class="flex-grow-1 message-input" @keyup.enter="sendPendingFiles">
                    </v-text-field>
                    <v-btn icon class="send-btn ml-2" @click="sendPendingFiles">
                      <v-icon>mdi-send</v-icon>
                    </v-btn>
                  </div>
                </div>

                <!-- Normal Input (shows when no file is selected) -->
                <template v-else>
                  <!-- Emoji Menu -->
                  <v-menu offset-y transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-emoticon-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card class="pa-2 emoji-picker">
                      <div class="d-flex flex-wrap">
                        <span v-for="emoji in emojis" :key="emoji" class="emoji-item" @click="addEmoji(emoji)">
                          {{ emoji }}
                        </span>
                      </div>
                    </v-card>
                  </v-menu>

                  <v-text-field v-model="newMessage" placeholder="Type a message..." outlined dense
                    class="flex-grow-1 message-input" @keyup.enter="sendMessage" @input="sendTyping">
                  </v-text-field>
                  <v-btn icon class="send-btn" @click="handleSendButtonClick">
                    <v-icon>{{ newMessage ? "mdi-send" : "mdi-microphone" }}</v-icon>
                  </v-btn>
                </template>
              </template>
            </v-card-actions>
          </div>
          <div v-else class="d-flex flex-grow-1 align-center justify-center grey--text">
            <h3>👈 Select a user to start chat</h3>
          </div>
        </div>
      </v-card>

      <!-- Group Members Dialog (Enhanced with Admin Features) -->
      <v-dialog v-model="showMembersDialog" max-width="480px">
        <v-card>
          <v-card-title class="py-3 px-4 d-flex align-center" style="font-size: 18px;">
            <v-icon left size="22">mdi-account-group</v-icon>
            <span>Members ({{ currentMemberCount }})</span>
            <v-spacer></v-spacer>
            <!-- Add Member Button (Admin Only) - Compact -->
            <v-btn
              v-if="isCurrentUserAdmin"
              color="primary"
              small
              text
              @click="openAddMemberDialog"
              class="mr-1"
            >
              <v-icon left small>mdi-plus</v-icon>
              Add
            </v-btn>
            <v-btn icon small @click="showMembersDialog = false">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pa-0">
            <v-list v-if="groupMembers.length > 0" class="py-1">
              <v-list-item
                v-for="(member, index) in groupMembers"
                :key="index"
                @click="!member.isYou && openOneToOneChatFromGroup(member)"
                :class="{ 'clickable-member': !member.isYou }"
                dense
              >
                <v-list-item-avatar color="primary" size="38" class="my-1 d-flex align-center justify-center">
                  <span class="white--text text-caption font-weight-bold" style="line-height: 1;">
                    {{ member.name ? member.name[0].toUpperCase() : '?' }}
                  </span>
                </v-list-item-avatar>

                <v-list-item-content class="py-2">
                  <v-list-item-title class="text-body-2">
                    {{ member.name }}
                    <v-chip
                      v-if="member.isAdmin"
                      x-small
                      color="success"
                      text-color="white"
                      class="ml-1"
                      style="height: 18px; font-size: 10px;"
                    >
                      Admin
                    </v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption">{{ member.position }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action v-if="member.isYou">
                  <v-chip x-small color="primary" text-color="white" style="height: 20px;">You</v-chip>
                </v-list-item-action>

                <!-- Admin Actions (Admin Only, not on self or other admin) -->
                <v-list-item-action v-else-if="isCurrentUserAdmin && !member.isAdmin" class="d-flex flex-row" style="gap: 4px;">
                  <!-- Make Admin Button -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="confirmMakeAdmin(member)"
                        class="admin-action-btn"
                      >
                        <v-icon small>mdi-shield-crown</v-icon>
                      </v-btn>
                    </template>
                    <span>Make Admin</span>
                  </v-tooltip>

                  <!-- Remove Member Button -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="confirmRemoveMember(member)"
                        class="admin-action-btn"
                      >
                        <v-icon small>mdi-account-remove</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Member</span>
                  </v-tooltip>
                </v-list-item-action>

                <v-list-item-action v-else>
                  <v-icon small color="grey lighten-1">mdi-message-text-outline</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="pa-4 text-center grey--text">
              No members found
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Action Buttons -->
          <v-card-actions class="pa-3 d-flex justify-space-between" style="gap: 8px;">
            <v-btn
              v-if="isCurrentUserAdmin"
              color="error"
              text
              small
              @click="confirmDeleteGroup"
            >
              <v-icon left small>mdi-delete</v-icon>
              Delete Group
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              outlined
              small
              @click="confirmExitGroup"
            >
              <v-icon left small>mdi-exit-to-app</v-icon>
              Exit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Add Member Dialog -->
      <v-dialog v-model="showAddMemberDialog" max-width="480px" persistent>
        <v-card>
          <v-card-title class="py-3 px-4 primary white--text" style="font-size: 18px;">
            <v-icon left color="white" size="22">mdi-account-plus</v-icon>
            Add Members
            <v-chip v-if="selectedUsersToAdd.length > 0" x-small color="white" text-color="primary" class="ml-2">
              {{ selectedUsersToAdd.length }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn icon dark small @click="closeAddMemberDialog">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pa-3">
            <!-- Search field -->
            <v-text-field
              v-model="memberSearchQuery"
              label="Search users"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              hide-details
              clearable
              class="mb-2"
            ></v-text-field>

            <!-- User list with checkboxes -->
            <v-list max-height="280" style="overflow-y: auto;" class="py-1">
              <v-list-item
                v-for="user in availableUsersForAdd"
                :key="user.id"
                @click="toggleUserSelection(user)"
                dense
                class="px-1"
              >
                <v-list-item-action class="mr-2 my-0">
                  <v-checkbox
                    :input-value="isUserSelected(user)"
                    @click.stop="toggleUserSelection(user)"
                    color="primary"
                    hide-details
                    dense
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-avatar color="primary" size="36" class="my-1 d-flex align-center justify-center">
                  <span class="white--text text-caption font-weight-bold" style="line-height: 1;">{{ user.user_name[0].toUpperCase() }}</span>
                </v-list-item-avatar>
                <v-list-item-content class="py-2">
                  <v-list-item-title class="text-body-2">{{ user.user_name }}</v-list-item-title>
                  <v-list-item-subtitle class="text-caption">{{ user.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <div v-if="availableUsersForAdd.length === 0" class="text-center grey--text text-caption pa-4">
              All users are already in the group
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="py-2 px-3">
            <v-spacer></v-spacer>
            <v-btn text small @click="closeAddMemberDialog">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              small
              depressed
              @click="addMembersToGroup"
              :disabled="selectedUsersToAdd.length === 0"
              :loading="addingMember"
            >
              <v-icon left small>mdi-plus</v-icon>
              Add {{ selectedUsersToAdd.length > 0 ? `(${selectedUsersToAdd.length})` : '' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Remove Member Confirmation Dialog -->
      <v-dialog v-model="showRemoveMemberDialog" max-width="420px" persistent>
        <v-card>
          <v-card-title class="py-3 px-4" style="font-size: 18px;">
            <v-icon left color="error" size="22">mdi-account-remove</v-icon>
            Remove Member
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="py-4 px-4">
            <p class="text-body-2 mb-0" style="line-height: 1.5;">
              Remove <strong>{{ memberToRemove ? memberToRemove.name : '' }}</strong> from the group?
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="py-2 px-3">
            <v-spacer></v-spacer>
            <v-btn text small @click="closeRemoveMemberDialog">
              Cancel
            </v-btn>
            <v-btn
              color="error"
              small
              depressed
              @click="removeMemberFromGroup"
              :loading="removingMember"
            >
              <v-icon left small>mdi-account-remove</v-icon>
              Remove
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Exit Group Confirmation Dialog -->
      <v-dialog v-model="showExitGroupDialog" max-width="420px" persistent>
        <v-card>
          <v-card-title class="py-3 px-4" style="font-size: 18px;">
            <v-icon left color="warning" size="22">mdi-exit-to-app</v-icon>
            Exit Group
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="py-4 px-4">
            <p class="text-body-2 mb-3" style="line-height: 1.5;">
              Are you sure you want to exit this group?
            </p>

            <!-- Warning for admin (WhatsApp style) -->
            <v-alert
              v-if="isCurrentUserAdmin"
              type="info"
              dense
              text
              class="mb-0"
              style="font-size: 12px;"
            >
              <strong>Note:</strong> You're the admin. If you exit, the group will continue without an admin.
            </v-alert>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="py-2 px-3">
            <v-spacer></v-spacer>
            <v-btn text small @click="closeExitGroupDialog">
              Cancel
            </v-btn>
            <v-btn
              color="error"
              small
              depressed
              @click="exitGroup"
              :loading="exitingGroup"
            >
              <v-icon left small>mdi-exit-to-app</v-icon>
              Exit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Group Confirmation Dialog -->
      <v-dialog v-model="showDeleteGroupDialog" max-width="420px" persistent>
        <v-card>
          <v-card-title class="py-3 px-4" style="font-size: 18px;">
            <v-icon left color="error" size="22">mdi-alert-circle</v-icon>
            Delete Group
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="py-4 px-4">
            <p class="text-body-2 mb-3" style="line-height: 1.5;">
              Are you sure you want to delete "<strong>{{ activeConversation && activeConversation.name }}</strong>"?
            </p>
            <v-alert type="error" dense text class="mb-0" style="font-size: 13px;">
              This action cannot be undone. All members will lose access.
            </v-alert>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="py-2 px-3">
            <v-spacer></v-spacer>
            <v-btn text small @click="closeDeleteGroupDialog">
              Cancel
            </v-btn>
            <v-btn
              color="error"
              small
              depressed
              @click="deleteGroup"
              :loading="deletingGroup"
              :disabled="deletingGroup"
            >
              <v-icon left small>mdi-delete</v-icon>
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Make Admin Confirmation Dialog -->
      <v-dialog v-model="showMakeAdminDialog" max-width="480px" persistent>
        <v-card class="make-admin-dialog">
          <v-card-title class="py-3 px-4 d-flex align-items-center" style="font-size: 18px; background: linear-gradient(135deg, #4CAF50, #66BB6A); color: white;">
            <v-icon left color="white" size="24">mdi-shield-crown</v-icon>
            <span>Make Admin</span>
            <v-spacer></v-spacer>
            <v-btn icon dark small @click="closeMakeAdminDialog" :disabled="makingAdmin">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="py-4 px-4">
            <div class="text-center mb-3">
              <v-avatar size="60" color="success lighten-4" class="mb-2">
                <span class="text-h5 success--text text--darken-2 font-weight-bold">
                  {{ memberToPromote ? memberToPromote.name[0].toUpperCase() : '?' }}
                </span>
              </v-avatar>
              <div class="text-h6 font-weight-medium">{{ memberToPromote ? memberToPromote.name : '' }}</div>
              <div class="text-caption grey--text">{{ memberToPromote ? memberToPromote.position : '' }}</div>
            </div>

            <v-divider class="my-3"></v-divider>

            <p class="text-body-2 mb-3" style="line-height: 1.6;">
              Make <strong>{{ memberToPromote ? memberToPromote.name : '' }}</strong> the new admin of this group?
            </p>

            <v-alert type="info" dense text class="mb-0" style="font-size: 13px;">
              <v-icon small class="mr-1">mdi-information</v-icon>
              <strong>Note:</strong> You will become a regular member and <strong>{{ memberToPromote ? memberToPromote.name : '' }}</strong> will have full admin privileges (add/remove members, delete group).
            </v-alert>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="py-3 px-4">
            <v-spacer></v-spacer>
            <v-btn text small @click="closeMakeAdminDialog" :disabled="makingAdmin">
              Cancel
            </v-btn>
            <v-btn
              color="success"
              small
              depressed
              @click="makeAdmin"
              :loading="makingAdmin"
              :disabled="makingAdmin"
              class="px-4"
            >
              <v-icon left small>mdi-shield-crown</v-icon>
              Make Admin
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Group Action Snackbar (WhatsApp/Teams style) -->
      <v-snackbar
        v-model="groupActionSnackbar"
        :color="groupActionColor"
        :timeout="3500"
        top
        right
        rounded="pill"
        elevation="12"
        class="group-action-snackbar"
      >
        <div class="d-flex align-center">
          <v-icon small class="mr-2" color="white">{{ groupActionIcon }}</v-icon>
          <span style="font-family: 'Poppins', sans-serif; font-size: 13px; font-weight: 500;">
            {{ groupActionText }}
          </span>
        </div>
        <template v-slot:action="{ attrs }">
          <v-btn icon x-small v-bind="attrs" @click="groupActionSnackbar = false">
            <v-icon small color="white">mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>

      <!-- Create Group Dialog - Step 1: Group Name -->
      <v-dialog v-model="showCreateGroupDialog" max-width="500px" persistent>
        <v-card>
          <v-card-title class="headline primary white--text">
            <v-icon left color="white">mdi-account-group-outline</v-icon>
            Create New Group
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeCreateGroupDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pa-6">
            <p class="subtitle-1 mb-4">Enter a name for your new group</p>
            <v-text-field
              v-model="newGroupName"
              label="Group Name"
              placeholder="e.g., Team Chat, Project Group"
              outlined
              dense
              autofocus
              :rules="[v => !!v || 'Group name is required']"
              @keyup.enter="proceedToMemberSelection"
            >
              <template v-slot:prepend-inner>
                <v-icon color="primary">mdi-format-text</v-icon>
              </template>
            </v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn text @click="closeCreateGroupDialog">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="proceedToMemberSelection"
              :disabled="!newGroupName || newGroupName.trim() === ''"
            >
              Next
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Create Group Dialog - Step 2: Select Members -->
      <v-dialog v-model="showSelectMembersDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title class="headline primary white--text">
            <v-icon left color="white">mdi-account-multiple-plus</v-icon>
            Add Members to "{{ newGroupName }}"
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeSelectMembersDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Search bar for filtering users -->
          <v-card-text class="pa-4">
            <v-text-field
              v-model="memberSearchQuery"
              label="Search users"
              placeholder="Type to search..."
              outlined
              dense
              clearable
              prepend-inner-icon="mdi-magnify"
              class="mb-3"
            ></v-text-field>

            <!-- Selected members count -->
            <v-chip
              v-if="selectedMembers.length > 0"
              color="success"
              text-color="white"
              class="mb-3"
            >
              <v-icon left small>mdi-check-circle</v-icon>
              {{ selectedMembers.length }} {{ selectedMembers.length === 1 ? 'member' : 'members' }} selected
            </v-chip>

            <!-- User list for selection -->
            <div style="max-height: 400px; overflow-y: auto;">
              <v-list dense>
                <v-list-item
                  v-for="user in filteredUsersForGroup"
                  :key="user.id"
                  @click="toggleMemberSelection(user)"
                  class="mb-1"
                  :class="{ 'selected-member-item': isUserSelected(user.id) }"
                >
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="isUserSelected(user.id)"
                      color="primary"
                      @click.stop="toggleMemberSelection(user)"
                    ></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-avatar color="primary" class="select-member-avatar d-flex align-center justify-center">
                    <span class="white--text font-weight-bold" style="line-height: 1;">{{ (user.user_name ? user.user_name[0] : '?').toUpperCase() }}</span>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ user.user_name }}</v-list-item-title>
                    <v-list-item-subtitle class="caption grey--text">
                      {{ user.email }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      v-if="isUserSelected(user.id)"
                      icon
                      small
                      color="success"
                    >
                      <v-icon small>mdi-check</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-btn text @click="backToGroupName">
              <v-icon left>mdi-arrow-left</v-icon>
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="closeSelectMembersDialog">
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              @click="createGroup"
              :disabled="selectedMembers.length === 0 || creatingGroup"
              :loading="creatingGroup"
            >
              <v-icon left>mdi-check</v-icon>
              Create Group
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Message Confirmation Dialog -->
      <v-dialog v-model="showDeleteDialog" max-width="380px" persistent>
        <v-card>
          <v-card-title class="py-3 px-4" style="font-size: 18px;">
            <v-icon left color="error" size="22">mdi-delete-outline</v-icon>
            Delete Message
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="py-4 px-4">
            <p class="text-body-2 mb-0" style="line-height: 1.5;">
              Delete this message? This cannot be undone.
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="py-2 px-3">
            <v-spacer></v-spacer>
            <v-btn text small @click="cancelDelete">
              Cancel
            </v-btn>
            <v-btn
              color="error"
              small
              depressed
              @click="confirmDelete"
              :loading="deletingMessage"
              :disabled="deletingMessage"
            >
              <v-icon left small>mdi-delete</v-icon>
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Image Viewer Dialog -->
      <v-dialog v-model="showImageViewerDialog" max-width="600px">
        <v-card style="background: #000; position: relative;">
          <v-btn icon dark absolute top right @click="showImageViewerDialog = false" style="z-index: 1;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-title v-if="imageViewerTitle" class="white--text py-2" style="font-size: 14px;">
            {{ imageViewerTitle }}
          </v-card-title>
          <v-card-text class="pa-0 d-flex justify-center align-center" style="min-height: 300px;">
            <img
              v-if="imageViewerUrl"
              :src="imageViewerUrl"
              :alt="imageViewerTitle"
              style="max-width: 100%; max-height: 500px; object-fit: contain;"
            />
            <div v-else class="white--text text-center pa-8">
              <v-icon color="grey" size="80">mdi-account-circle</v-icon>
              <div class="mt-2" style="opacity: 0.7;">No profile picture</div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
import { connectSocket, joinRoom, sendMessage } from "../../services/socket";
import axios from "axios";
// import { Presence } from "phoenix"
export default {
  data() {
    return {
      showChat: true,
      sidebar: true,
      activeTab: 0, // 0 = All, 1 = Groups
      searchQuery: "",
      socket: null,
      channel: null,
      usersList: [],
      groupsList: [], // For groups
      globalChannels: null,
      activeConversation: null,
      loader_check: true,
      logged_user_id: localStorage.getItem("USER_ID"),
      token: localStorage.getItem("TOKEN"),
      domain_from_local_storage: localStorage.getItem("domain"),
      entity_id: Number(localStorage.getItem("ENTITY_ID")),
      isFamilyBook: localStorage.getItem("is_family_book") === "true",
      isBoardPage: localStorage.getItem("is_boardpage") === "true",
      messages: {},
      isOtherUserTyping: false,
      typingTimeout: null,
      otherUserOnline: false,
      emojis: ["😀", "😂", "😍", "😎", "🤔", "😢", "👍", "🔥", "🎉", "❤️", "🥳", "🙏", "😇", "🤩", "😡"],
      newMessage: "",
      // Voice recording
      isRecording: false,
      mediaRecorder: null,
      audioChunks: [],
      recordingTime: 0,
      recordingTimer: null,
      recordingMimeType: null,
      currentlyPlayingId: null, // Track which voice message is currently playing
      audioPlayer: null, // Reusable audio player instance
      // File preview
      pendingFiles: [],
      pendingFilesPreview: [],
      pendingAttachmentType: null,
      // Group members dialog
      showMembersDialog: false,
      groupMembers: [],
      // Create group dialogs
      showCreateGroupDialog: false,
      showSelectMembersDialog: false,
      newGroupName: '',
      selectedMembers: [],
      memberSearchQuery: '',
      creatingGroup: false,
      // Delete message confirmation
      showDeleteDialog: false,
      messageToDelete: null,
      deletingMessage: false,
      // Admin actions
      showAddMemberDialog: false,
      showRemoveMemberDialog: false,
      showExitGroupDialog: false,
      showDeleteGroupDialog: false,
      showMakeAdminDialog: false,
      memberToRemove: null,
      memberToPromote: null,
      availableUsersForAdd: [],
      selectedUsersToAdd: [],  // Changed to array for multiple selection
      addingMember: false,
      removingMember: false,
      exitingGroup: false,
      deletingGroup: false,
      makingAdmin: false,
      // Group action snackbar
      groupActionSnackbar: false,
      groupActionText: '',
      groupActionIcon: '',
      groupActionColor: '',
      // Image viewer dialog
      showImageViewerDialog: false,
      imageViewerUrl: null,
      imageViewerTitle: ''
    };
  },
  computed: {
    // Filter users based on search query for group creation
    filteredUsersForGroup() {
      if (!this.memberSearchQuery) {
        // Exclude current user from the list
        return this.usersList.filter(user => user.id !== parseInt(this.logged_user_id));
      }

      const query = this.memberSearchQuery.toLowerCase();
      return this.usersList.filter(user => {
        const matchesSearch = user.user_name.toLowerCase().includes(query) ||
                             (user.email && user.email.toLowerCase().includes(query));
        const notCurrentUser = user.id !== parseInt(this.logged_user_id);
        return matchesSearch && notCurrentUser;
      });
    },
    // Check if current user is the group admin
    isCurrentUserAdmin() {
      console.log('🔍 isCurrentUserAdmin check:');
      console.log('  activeConversation:', this.activeConversation);
      console.log('  isGroup:', this.activeConversation?.isGroup);

      if (!this.activeConversation || !this.activeConversation.isGroup) {
        console.log('  ❌ Not a group conversation');
        return false;
      }

      const currentGroup = this.groupsList.find(g => g.id === this.activeConversation.id);
      console.log('  currentGroup:', currentGroup);
      console.log('  creator_id:', currentGroup?.creator_id);
      console.log('  logged_user_id:', this.logged_user_id);
      console.log('  creator_id (number):', Number(currentGroup?.creator_id));
      console.log('  logged_user_id (number):', Number(this.logged_user_id));

      const isAdmin = currentGroup &&
             currentGroup.creator_id &&
             Number(currentGroup.creator_id) === Number(this.logged_user_id);

      console.log('  ✅ Is Admin?', isAdmin);
      return isAdmin;
    },
    // Get current member count (reactive)
    currentMemberCount() {
      return this.groupMembers.length;
    }
  },
  mounted() {
    this.searchUsers(); // Load all users by default (with logged user first)
    this.searchGroups(); // Load all groups/forums
    this.socket = connectSocket(this.token, this.logged_user_id, this.entity_id);
    this.globalChannel = this.socket.channel(`user:${this.logged_user_id}`, {});

    this.globalChannel.join()
      .receive("ok", resp => console.log("Joined global user channel:", resp))
      .receive("error", err => console.error("Failed to join global channel:", err));

    // Handle incoming messages for all users
    this.globalChannel.on("new_message", this.handleIncomingMessage);

    // Optional: handle typing/presence globally
    this.globalChannel.on("typing", this.handleTyping);
    this.globalChannel.on("presence_update", this.handlePresence);

    let presences = {}

    // channel.on("presence_state", (state) => {
    //   presences = Presence.syncState(presences, state)
    //   this.updateOnlineUsers(presences)
    // })

    // channel.on("presence_diff", (diff) => {
    //   presences = Presence.syncDiff(presences, diff)
    //   this.updateOnlineUsers(presences)
    // })

    //   this.globalChannel.on("message:delivered", (payload) => {
    //   const msgs = this.messages[payload.sender_id] || [];
    //   const msg = msgs.find(m => m.id === payload.id);
    //   if (msg) this.$set(msg, "status", "delivered");
    //   this.updateUserListLastMessage(payload.sender_id, { text: msg?.text, is_me: true, status: "delivered" });
    // });
    // this.globalChannels = this.socket.channel(`users:lobby`, {});
    // this.presence = new Presence(this.globalChannels);

    // this.globalChannels.join()
    //   .receive("ok", resp => {
    //     console.log("✅ Joined lobby:", resp);
    //    this.presence.onSync(() => {
    //   const list = this.presence.list((id, { metas }) => ({
    //     user_id: id,
    //     online_at: metas[0]?.online_at
    //   }));
    //   this.onlineUsers = list;

    //   // Update otherUserOnline manually
    //   this.otherUserOnline = this.onlineUsers.some(u => u.user_id !== this.logged_user_id);
    //   console.log("👥 Online users:", list, "Other user online?", this.otherUserOnline);
    // });
    // })
    // .receive("error", err => console.error("❌ Failed to join:", err));


    // Sync presence

    // Handle incoming messages for all users
    // this.globalChannels.on("new_message", this.handleIncomingMessage);
    // this.globalChannels.on("presence_state", payload => {
    //   console.log("🔵 Presence state:", payload)
    // })

    // this.globalChannels.on("presence_diff", payload => {
    //   console.log("🟠 Presence diff:", payload)
    // })
    // this.globalChannel.on("message:read", (payload) => {
    //   const msgs = this.messages[payload.sender_id] || [];
    //   const msg = msgs.find(m => m.id === payload.id);
    //   if (msg) this.$set(msg, "status", "read");
    //   this.updateUserListLastMessage(payload.sender_id, { text: msg?.text, is_me: true, status: "read" });
    // });

    this.globalChannel.on("message:delivered", this.handleDelivered);
    this.globalChannel.on("message:read", this.handleRead);

    // Real-time group creation: when another user adds me to a group,
    // refresh the groups list so it appears without needing a page refresh
    this.globalChannel.on("group_created", this.handleGroupCreated);
    this.globalChannel.on("group_updated", this.handleGroupCreated);
    this.globalChannel.on("added_to_group", this.handleGroupCreated);

  },
  beforeDestroy() {
    // Clean up audio player
    if (this.audioPlayer) {
      this.audioPlayer.pause();
      this.audioPlayer.src = '';
      this.audioPlayer = null;
    }

    // Clean up recording
    if (this.mediaRecorder && this.isRecording) {
      this.mediaRecorder.stop();
      if (this.mediaRecorder.stream) {
        this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
      }
    }

    // Clear timers
    if (this.recordingTimer) {
      clearInterval(this.recordingTimer);
    }
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    // Leave channels
    if (this.channel) {
      this.channel.leave();
    }
    if (this.globalChannel) {
      this.globalChannel.leave();
    }
  },
  methods: {
    // Helper to parse backend timestamp and ensure it's in correct format
    // Returns a displayable image URL from a profile_pic array.
    // Checks user's own pic first, then falls back to employee pic.
    // profile_pic structure: [{url: "...", content_binary: "...", file_content: "..."}]
    // Returns a displayable image URL from a profile_pic array (from users table).
    // profile_pic structure: [{url: "...", content_binary: "...", file_content: "..."}]
    getProfilePicUrl(profilePic) {
      if (!profilePic || !profilePic.length) return null;
      let entry = profilePic[0];
      // DB may store element as a JSON-encoded string instead of a parsed object
      if (typeof entry === 'string') {
        try { entry = JSON.parse(entry); } catch (e) { return null; }
      }
      return entry.url || entry.content_binary || entry.file_content || null;
    },

    // Returns the profile pic URL for a given sender_id by looking up the usersList.
    getSenderProfilePic(senderId) {
      const user = this.usersList.find(u => Number(u.id) === Number(senderId));
      return user ? this.getProfilePicUrl(user.profile_pic) : null;
    },

    parseBackendTimestamp(backendTimestamp) {
      if (!backendTimestamp) return new Date().toISOString();

      // If the timestamp doesn't end with 'Z' (UTC indicator), add it
      // This handles Elixir NaiveDateTime which doesn't include timezone
      let timestamp = backendTimestamp;
      if (typeof timestamp === 'string' && !timestamp.endsWith('Z') && !timestamp.includes('+')) {
        // Assume backend timestamp is in UTC and add 'Z' suffix
        timestamp = timestamp + 'Z';
      }

      return new Date(timestamp).toISOString();
    },
    updateOnlineUsers(presences) {
      this.onlineUsers = Object.keys(presences)
      console.log("Online users:", this.onlineUsers)
    },
    // Called when backend broadcasts group_created / added_to_group on global channel
    handleGroupCreated(payload) {
      console.log("Group event received, refreshing groups list:", payload);
      // Avoid duplicate if we just created this group ourselves (already in list)
      if (payload && payload.room_id) {
        const alreadyExists = this.groupsList.some(g => g.id === payload.room_id);
        if (alreadyExists) return;
      }
      // Refresh groups list so the new group appears in real-time
      this.searchGroups();
    },

    handleDelivered(payload) {
      const msgs = this.messages[payload.sender_id] || [];
      const msg = msgs.find(m => m.id === payload.id);
      if (msg) {
        this.$set(msg, "status", "delivered");
        // Update sidebar tick if this is the last message in that conversation
        const lastMsg = msgs[msgs.length - 1];
        if (lastMsg && lastMsg.id === payload.id) {
          const sidebarUser = this.usersList.find(u => Number(u.id) === Number(payload.sender_id));
          if (sidebarUser && sidebarUser.lastMessage) {
            this.$set(sidebarUser.lastMessage, 'status', 'delivered');
          }
        }
      }
    },
    handleRead(payload) {
      const msgs = this.messages[payload.sender_id] || [];
      const msg = msgs.find(m => m.id === payload.id);
      if (msg) {
        this.$set(msg, "status", "read");
        // Update sidebar tick immediately to blue when recipient reads the message
        const lastMsg = msgs[msgs.length - 1];
        if (lastMsg && lastMsg.id === payload.id) {
          const sidebarUser = this.usersList.find(u => Number(u.id) === Number(payload.sender_id));
          if (sidebarUser && sidebarUser.lastMessage) {
            this.$set(sidebarUser.lastMessage, 'status', 'read');
          }
        }
      }
    },
    handleIncomingMessage(payload) {
      // Detect group messages: backend sends chat_room_id with no specific receiver_id for groups
      if (payload.chat_room_id && !payload.receiver_id) {
        // Find the group by room_id — use Number() to avoid type-mismatch (string vs integer)
        const group = this.groupsList.find(g =>
          Number(g.room_id) === Number(payload.chat_room_id) ||
          Number(g.id) === Number(payload.chat_room_id)
        );
        if (group) {
          // Update group sidebar with this message so it appears without needing to open the group
          const isMeSender = Number(payload.sender_id) === Number(this.logged_user_id);
          const displayText = payload.is_voice ? "🎤 Voice Message"
            : payload.is_file
              ? (payload.file_type && payload.file_type.startsWith('image/') ? "📷 Photo"
                : payload.file_type && payload.file_type.startsWith('video/') ? "🎥 Video"
                : `📎 ${payload.file_name || 'File'}`)
              : payload.content;
          this.updateGroupListLastMessage(group.id, {
            text: displayText,
            is_me: isMeSender,
            status: "delivered",
            timestamp: this.parseBackendTimestamp(payload.inserted_at)
          });
        } else {
          // Unknown group — refresh so it appears in the sidebar
          this.searchGroups();
        }
        return; // Message bubble rendering is handled by the active room channel
      }

      const isMySelf = Number(payload.sender_id) === Number(this.logged_user_id);
      const isRecipient = Number(payload.receiver_id) === Number(this.logged_user_id);

      // GUARD: Only process messages where I am the sender or the recipient.
      // Without this, if the backend broadcasts to all users, every sidebar gets wrongly updated.
      if (!isMySelf && !isRecipient) return;

      const otherUserId = isMySelf ? payload.receiver_id : payload.sender_id;

      // Guard: if receiver_id is missing from payload, skip to avoid corrupting other users
      if (!otherUserId) return;

      //  Step 1: match temp_id → replace with real DB id (for optimistic messages I sent)
      if (payload.temp_id) {
        const msgs = this.messages[otherUserId] || [];
        const tempMsg = msgs.find(m => m.id === payload.temp_id);
        if (tempMsg) {
          tempMsg.id = payload.id;
          tempMsg.status = "sent";
          // For sent messages, the optimistic message already shows in the chat window.
          // Just update the sidebar with the confirmed timestamp and return.
          const displayText = payload.is_voice
            ? "🎤 Voice Message"
            : payload.is_file
              ? (payload.file_type && payload.file_type.startsWith('image/') ? "📷 Photo"
                : payload.file_type && payload.file_type.startsWith('video/') ? "🎥 Video"
                : `📎 ${payload.file_name || 'File'}`)
              : payload.content;
          this.updateUserListLastMessage(otherUserId, {
            text: displayText,
            is_me: true,
            status: "sent",
            timestamp: this.parseBackendTimestamp(payload.inserted_at)
          });
          return;
        }
      }

      // Step 2: ensure messages array exists
      if (!this.messages[otherUserId]) {
        this.$set(this.messages, otherUserId, []);
      }

      //  Step 3: avoid duplicates
      const exists = this.messages[otherUserId].some(m => m.id === payload.id);
      if (!exists) {
        this.messages[otherUserId].push({
          id: payload.id,
          from: isMySelf ? "me" : "them",
          text: payload.content,
          timestamp: this.parseBackendTimestamp(payload.inserted_at),
          time: new Date(this.parseBackendTimestamp(payload.inserted_at)).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          status: isMySelf ? "sent" : "delivered",
          is_voice: payload.is_voice || false,
          voice_data: payload.voice_data,
          duration: payload.duration,
          is_file: payload.is_file || false,
          file_data: payload.file_data,
          file_name: payload.file_name,
          file_type: payload.file_type,
          file_size: payload.file_size,
          attachment_type: payload.attachment_type
        });
      }

      // If I'm the recipient (not the sender), push delivery receipt so the sender's tick upgrades
      if (isRecipient && this.globalChannel) {
        this.globalChannel.push("message:delivered", { id: payload.id });
      }

      // Determine display text for sidebar
      let displayText = payload.content;
      if (payload.is_voice) {
        displayText = "🎤 Voice Message";
      } else if (payload.is_file) {
        if (payload.file_type && payload.file_type.startsWith('image/')) {
          displayText = "📷 Photo";
        } else if (payload.file_type && payload.file_type.startsWith('video/')) {
          displayText = "🎥 Video";
        } else {
          displayText = `📎 ${payload.file_name || 'File'}`;
        }
      }

      // Step 4: add user to sidebar if not present (for first-time senders)
      let user = this.usersList.find(u => u.id === otherUserId);
      if (!user) {
        user = {
          id: otherUserId,
          user_name: payload.sender_name || `User ${otherUserId}`,
          lastMessage: { text: displayText, is_me: isMySelf, status: isMySelf ? "sent" : "delivered", timestamp: this.parseBackendTimestamp(payload.inserted_at) },
          unreadCount: 0
        };
        this.usersList.push(user);
      }

      // Step 5: update sidebar lastMessage
      this.updateUserListLastMessage(otherUserId, {
        text: displayText,
        is_me: isMySelf,
        status: isMySelf ? "sent" : "delivered",
        timestamp: this.parseBackendTimestamp(payload.inserted_at)
      });

      // Step 6: auto-scroll if this is the active chat
      if (this.activeConversation && this.activeConversation.id === otherUserId) {
        this.$nextTick(() => this.scrollToBottom());
      }
    },
    // 🔹 Fetch only users who have chats in the current entity
    getAllUsers() {
      this.loader_check = true;
      console.log(" Fetching last messages with params:", {
        user_id: this.logged_user_id,
        entity_id: this.entity_id
      });

      axios
        .get(
          `last_messages?user_id=${this.logged_user_id}&entity_id=${this.entity_id}`
        )
        .then(res => {
          console.log(" Last messages response:", res.data);
          this.usersList = res.data.map(roomInfo => {
            // Default last message object
            //   console.log("roominfo", roomInfo)
            let unreadCount = 0;
            let lastMessage = {
              text: roomInfo.content,
              timestamp: this.parseBackendTimestamp(roomInfo.inserted_at),
              time: new Date(this.parseBackendTimestamp(roomInfo.inserted_at)).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit"
              }),
              is_me: roomInfo.is_me,
              status: roomInfo.status // <-- coming from backend
            };

            //  If I'm the receiver & message is still "sent" in this entity
            if (!roomInfo.is_me && roomInfo.status === "sent") {
              axios
                .post(`/messages/${roomInfo.id}/mark_delivered`, {
                  entity_id: this.entity_id,
                })
                .then(() => {
                  lastMessage.status = "delivered"; // update local copy
                  //   console.log("Marked message as delivered:");
                  // let unreadCount = 0;
                  // If I am the receiver and message is not read
                })
                .catch(err => console.error("Failed to mark delivered:", err));
            }
            if (!roomInfo.is_me && roomInfo.status !== "read") {
              unreadCount = 1; // you can also count from backend if multiple
            }

            return {
              user_name: roomInfo.other_user_name,
              id: roomInfo.other_user_id,
              lastMessage,
              unreadCount
            };
          });

          // Sidebar conversation format
          this.conversations = this.usersList.map(u => ({
            id: u.id,
            name: u.user_name,
            avatar: u.user_name ? u.user_name[0].toUpperCase() : "?",
            preview: u.lastMessage.text,
            users: [u],
            online: false,
            is_me: u.lastMessage.is_me
          }));

          // Sort by most recent message
          this.sortConversationsByTime();

          this.loader_check = false;
        })
        .catch(err => {
          console.error("Error fetching last messages:", err);
          console.error("Error response:", err.response?.data);
          console.error("Error status:", err.response?.status);
          this.loader_check = false;
        });

    },
    // 🔹 Search users from current entity (all users by default, with logged user first)
    searchUsers() {

      this.loader_check = true;
      // Always call search_users API (empty search returns all users)
      const searchQuery = this.searchQuery || ""; // Use empty string if no search query

      // Determine which flag to send based on local storage
      let filterFlag = "starr_flag"; // default
      if (this.isFamilyBook) {
        filterFlag = "family_book_flag";
      } else if (this.isBoardPage) {
        filterFlag = "board_flag";
      }

      console.log(" Searching users with filter:", {
        isFamilyBook: this.isFamilyBook,
        isBoardPage: this.isBoardPage,
        filterFlag: filterFlag,
        entity_id: this.entity_id
      });

      const apiUrl = `search_users?user_id=${this.logged_user_id}&search=${searchQuery}&entity_id=${this.entity_id}&filter_flag=${filterFlag}`;
      axios
        .get(apiUrl)
        .then((res) => {
         
          this.usersList = res.data.map((userInfo) => ({
            user_name: userInfo.is_me ? `${userInfo.user_name} (You)` : userInfo.user_name,
            id: userInfo.id,
            is_me: userInfo.is_me || false, // Track if this is the logged-in user
            lastMessage: userInfo.last_message
              ? {
                text: userInfo.last_message.is_voice
                  ? "🎤 Voice Message"
                  : userInfo.last_message.is_file
                    ? (userInfo.last_message.file_type && userInfo.last_message.file_type.startsWith('image/') ? "📷 Photo"
                      : userInfo.last_message.file_type && userInfo.last_message.file_type.startsWith('video/') ? "🎥 Video"
                      : `📎 ${userInfo.last_message.file_name || 'File'}`)
                    : userInfo.last_message.content,
                timestamp: this.parseBackendTimestamp(userInfo.last_message.inserted_at),
                time: new Date(this.parseBackendTimestamp(userInfo.last_message.inserted_at)).toLocaleTimeString(
                  [],
                  { hour: "2-digit", minute: "2-digit" }
                ),
                is_me: Number(userInfo.last_message.sender_id) === Number(this.logged_user_id),
                status: userInfo.last_message.status || "sent"
              }
              : { text: "", timestamp: null, time: "", is_me: false, status: "" },
            unreadCount: 0,
            profile_pic: userInfo.profile_pic || []
          }));

          // Sort by most recent message (initial sort using search_users data)
          this.sortConversationsByTime();

          this.loader_check = false;

          // Override last messages with accurate per-user data from last_messages API
          // (search_users API may return a global last message instead of per-user)
          this.fetchLastMessages();
        })
        .catch((err) => {
          console.error("Error searching users:", err);
          this.loader_check = false;
        });
    },

    // Fetch accurate per-user last messages and update sidebar
    fetchLastMessages() {
      axios
        .get(`last_messages?user_id=${this.logged_user_id}&entity_id=${this.entity_id}`)
        .then((res) => {
          // Reset all users: no last message, no unread badge
          this.usersList.forEach(u => {
            this.$set(u, 'lastMessage', { text: "", timestamp: null, is_me: false, status: "" });
            this.$set(u, 'unreadCount', 0);
          });

          res.data.forEach((roomInfo) => {
            const user = this.usersList.find(u => Number(u.id) === Number(roomInfo.other_user_id));
            if (!user) return;

            let displayText = roomInfo.content || "";
            if (roomInfo.is_voice) {
              displayText = "🎤 Voice Message";
            } else if (roomInfo.is_file) {
              if (roomInfo.file_type && roomInfo.file_type.startsWith('image/')) displayText = "📷 Photo";
              else if (roomInfo.file_type && roomInfo.file_type.startsWith('video/')) displayText = "🎥 Video";
              else displayText = `📎 ${roomInfo.file_name || 'File'}`;
            }

            this.$set(user, 'lastMessage', {
              text: displayText,
              timestamp: this.parseBackendTimestamp(roomInfo.inserted_at),
              is_me: roomInfo.is_me,
              status: roomInfo.status || "sent"
            });

            // Restore unread badge: only when the last message was sent TO me and not yet read
            if (!roomInfo.is_me && roomInfo.status !== "read") {
              user.unreadCount = roomInfo.unread_count || 1;
            }
          });

          // Re-sort with accurate timestamps
          this.sortConversationsByTime();
        })
        .catch((err) => {
          console.error("Error fetching last messages:", err);
        });
    },

    // Fetch last message for each group from backend and update group sidebar
    fetchGroupLastMessages() {
      if (!this.groupsList || this.groupsList.length === 0) return;

      // Only fetch for custom groups (they have a known room_id)
      const customGroups = this.groupsList.filter(g => g.is_custom_group && g.room_id);

      customGroups.forEach((group) => {
        axios
          .get(`group_messages?chatroom_id=${group.room_id}&entity_id=${this.entity_id}&limit=1`)
          .then((res) => {
            const data = res.data && res.data.data;
            if (!data || data.length === 0) return;
            const lastMsg = data[data.length - 1];
            const displayText = lastMsg.is_voice ? "🎤 Voice Message"
              : lastMsg.is_file
                ? (lastMsg.file_type && lastMsg.file_type.startsWith('image/') ? "📷 Photo"
                  : lastMsg.file_type && lastMsg.file_type.startsWith('video/') ? "🎥 Video"
                  : `📎 ${lastMsg.file_name || 'File'}`)
              : lastMsg.content;
            const isMeSender = Number(lastMsg.sender_id) === Number(this.logged_user_id);
            // Directly set lastMessage without going through updateGroupListLastMessage,
            // so we can control unreadCount independently (always 0 on refresh — group
            // messages have no per-user read tracking, so we can't know if you've seen it).
            const grp = this.groupsList.find(g => g.id === group.id);
            if (grp) {
              this.$set(grp, 'lastMessage', {
                text: displayText,
                is_me: isMeSender,
                status: lastMsg.status || "sent",
                timestamp: this.parseBackendTimestamp(lastMsg.inserted_at)
              });
              grp.unreadCount = 0; // Always 0 on refresh — unread badge only increments in real-time
              this.sortGroupsByTime();
            }
          })
          .catch(() => {}); // silently skip groups that fail
      });
    },

    //  Open chat with selected user (create/join chatroom if needed in current entity)
    selectConversation(user) {
      // this.newMessage = {};
      this.activeConversation = user;

      const otherUserId = user.id;
      if (this.channel) this.channel.leave(); // leave old room
      // console.log("Selected user:", user.id);
      axios
        .post("chat_room_details", {
          participant_ids: Number(user.id),
          type: "private",
          user_id: Number(this.logged_user_id),
          entity_id: this.entity_id
        })
        .then((res) => {
          const roomId = res.data.room_id;

          // Join the socket room
          const { channel, presence } = joinRoom(roomId, otherUserId, {
            onJoin: (resp) => {
              // Reset unread badge when entering chat
              user.unreadCount = 0;
              // mark_all_read is now called AFTER messages load (below),
              // only when the recipient actually has unread messages to mark.
            },
            onMessage: (payload) => {
              //   console.log("New message payload:", payload);
              if (payload.chat_room_id === roomId) {
                if (!this.messages[user.id]) {
                  this.$set(this.messages, user.id, []);
                }

                //  Check if this is an update to an optimistic message (has temp_id)
                let existingMsg = null;
                if (payload.temp_id) {
                  existingMsg = this.messages[user.id].find(m => m.id === payload.temp_id);
                }

                if (existingMsg) {
                  //  Update the existing optimistic message with real ID
                  console.log("Updating optimistic message", payload.temp_id, "with real ID", payload.id);
                  this.$set(existingMsg, 'id', payload.id); // Replace temp ID with real database ID
                  this.$set(existingMsg, 'status', 'sent');
                  this.$set(existingMsg, 'timestamp', this.parseBackendTimestamp(payload.inserted_at));
                  this.$set(existingMsg, 'time', new Date(this.parseBackendTimestamp(payload.inserted_at)).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  }));
                } else {
                  // 🔹 New message from another user or no temp_id found
                  const msg = {
                    id: payload.id, //  important to track message status
                    from: payload.sender_id == this.logged_user_id ? "me" : "other",
                    text: payload.content,
                    timestamp: this.parseBackendTimestamp(payload.inserted_at),
                    time: new Date(this.parseBackendTimestamp(payload.inserted_at)).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    }),
                    status: "delivered", // default status
                    // Voice message fields
                    is_voice: payload.is_voice || false,
                    voice_data: payload.voice_data,
                    duration: payload.duration,
                    // File attachment fields
                    is_file: payload.is_file || false,
                    file_data: payload.file_data,
                    file_name: payload.file_name,
                    file_type: payload.file_type,
                    file_size: payload.file_size,
                    attachment_type: payload.attachment_type
                  };
                  // console.log("Payload sender 1") ;
                  this.messages[user.id].push(msg);
                  this.scrollToBottom();

                  // 🔹 Send "delivered" acknowledgment if the message is from other user
                  if (payload.sender_id != this.logged_user_id) {
                    //   console.log("Payload sender 2");
                    //  this.updateUserListLastMessage(user.id, payload.content, false,"delivered");
                    this.channel.push("message:delivered", { id: payload.id });
                    this.$set(msg, "status", "delivered"); // Update status to delivered
                  }
                }
              }
              this.markMessagesRead();
            },
            onTyping: (payload) => {
              // console.log("Typing payload:", payload);
              if (payload.user_id !== Number(this.logged_user_id)) {
                this.isOtherUserTyping = payload.typing;
              }
            },
            onPresence: (status) => {
              console.log("Presence update for user:", user.id, "Status:", status);
              this.otherUserOnline = status.online; // reactive variable
            },
            onError: (err) => console.error(err),
          });
          this.channel = channel;
          this.presence = presence;
          //typing indicator
          this.channel.on("typing", (payload) => {
            //   console.log("Typing payload:", payload);
            if (payload.user_id !== Number(this.logged_user_id)) {
              this.isOtherUserTyping = payload.typing;
            }
          });
          //messages handler
          this.channel.on("message:delivered", (payload) => {
            const msgs = this.messages[this.activeConversation.id] || [];
            const msg = msgs.find((m) => m.id === payload.id);
            // console.log("Payload sender 3", this.usersList);
            //   console.log("Payload sender 4", payload.sender_id);
            // Find the sidebar user entry
            const sidebarUser = this.usersList.find(u => u.id === payload.sender_id);
            //   console.log("Delivered payload:", payload, "Found message:", msg, "Sidebar user:", sidebarUser);
            if (sidebarUser) {
              // 🔹 Increase unread count only if it's NOT the active conversation
              if (!this.activeConversation || this.activeConversation.id !== sidebarUser.id) {
                sidebarUser.unreadCount = sidebarUser.unreadCount || 0;
                if (msg && msg.status !== "delivered") {
                  sidebarUser.unreadCount += 1;
                }
              }
              //   console.log("Updated unread count for user", sidebarUser.id, "to", sidebarUser.unreadCount);
              // 🔹 Update last message preview in sidebar
              this.updateUserListLastMessage(sidebarUser.id, {
                text: msg ? msg.text : "",
                is_me: msg ? (msg.from === "me") : false,
                status: "delivered"
              });
            }
            // 🔹 Update in active chat window
            if (msg) {
              this.$set(msg, "status", "delivered");
            }
          });
          this.channel.on("message:read", (payload) => {
            const msgs = this.messages[this.activeConversation.id] || [];
            const msg = msgs.find((m) => m.id === payload.id);
            if (msg) {
              this.$set(msg, "status", "read");
              // Update sidebar tick to blue immediately — no need to close/reopen chat
              const lastMsg = msgs[msgs.length - 1];
              if (lastMsg && lastMsg.id === payload.id) {
                const sidebarUser = this.usersList.find(u => u.id === this.activeConversation.id);
                if (sidebarUser && sidebarUser.lastMessage) {
                  this.$set(sidebarUser.lastMessage, 'status', 'read');
                }
              }
            }
          });

          // Load past messages for this room from current entity
          axios
            .get(
              `messages?chatroom_id=${roomId}&entity_id=${this.entity_id}`
            )
            .then((res) => {
              // Clear existing messages to avoid duplicates when reopening
              this.$set(this.messages, user.id, []);

              //   console.log("Past messages:", res.data.data);
              res.data.data.forEach((v) => {

                this.messages[user.id].push({
                  id: v.id,  // Add message ID for tracking status updates
                  from: v.sender_id == this.logged_user_id ? "me" : "other",
                  text: v.content,
                  timestamp: this.parseBackendTimestamp(v.inserted_at),
                  time: new Date(this.parseBackendTimestamp(v.inserted_at)).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  }),
                  status: v.status,
                  // Voice message fields
                  is_voice: v.is_voice || false,
                  voice_data: v.voice_data,
                  duration: v.duration,
                  // File attachment fields
                  is_file: v.is_file || false,
                  file_data: v.file_data,
                  file_name: v.file_name,
                  file_type: v.file_type,
                  file_size: v.file_size,
                  attachment_type: v.attachment_type
                });
              });

              // Update sidebar with the actual last message from history (not inside loop)
              if (res.data.data.length > 0) {
                const lastMsg = res.data.data[res.data.data.length - 1];
                const displayText = lastMsg.is_voice
                  ? "🎤 Voice Message"
                  : lastMsg.is_file
                    ? (lastMsg.file_type && lastMsg.file_type.startsWith('image/') ? "📷 Photo"
                      : lastMsg.file_type && lastMsg.file_type.startsWith('video/') ? "🎥 Video"
                      : `📎 ${lastMsg.file_name || 'File'}`)
                    : lastMsg.content;
                this.updateUserListLastMessage(user.id, {
                  text: displayText,
                  is_me: lastMsg.sender_id == this.logged_user_id,
                  status: lastMsg.status,
                  timestamp: this.parseBackendTimestamp(lastMsg.inserted_at)
                });
              }

              // Mark messages as read ONLY if I am the RECIPIENT (not the sender).
              // Calling mark_all_read as the sender would corrupt the read status.
              const unreadFromOther = this.messages[user.id].filter(
                m => m.from === "other" && m.status !== "read"
              );
              if (unreadFromOther.length > 0) {
                axios.post("/mark_all_read", {
                  chatroom_id: roomId,
                  user_id: this.logged_user_id,
                  entity_id: this.entity_id
                }).then(() => {
                  unreadFromOther.forEach((msg) => {
                    if (this.channel) this.channel.push("message:read", { id: msg.id });
                    this.$set(msg, "status", "read");
                  });
                });
              }
              // this.updateUserListLastMessage(this.activeConversation.id, this.newMessage, true, "delivered");

              // this.updateUserListLastMessage(user.id, {
              //   text: this.newMessage,
              //   is_me: true,
              //   // status: "read"
              // });

              // this.updateUserListLastMessage(this.activeConversation.id, {
              //   text: payload.content,
              //   is_me: false,
              //   status: "read"
              // });

              this.scrollToBottom();
            });
        });
    },
    markMessagesRead() {
      if (!this.activeConversation || !this.channel) return;
      const msgs = this.messages[this.activeConversation.id] || [];
      const unreadMessages = msgs.filter(
        (m) => m.from === "other" && m.status !== "read"
      );
      unreadMessages.forEach((msg) => {
        // Push "read" event to server for each unread message
        this.channel.push("message:read", { id: msg.id });
        this.$set(msg, "status", "read"); // Update UI immediately
      });
    },
    updateUserListLastMessage(userId, { text, is_me, status, timestamp }) {
      //   console.log("user", userId);
      const user = this.usersList.find(u => u.id === userId);
      if (user) {
        user.lastMessage = {
          text,
          is_me,
          status,
          timestamp: timestamp || new Date().toISOString()
        };
        //  If the message is NOT from me, and it's not read → increase unread count
        if (!is_me && status !== "read") {
          user.unreadCount = (user.unreadCount || 0) + 1;
        }
        // If I'm inside that active conversation → reset unread count
        if (this.activeConversation && this.activeConversation.id === userId) {
          user.unreadCount = 0;
        }

        // Sort conversations by most recent message
        this.sortConversationsByTime();
      }
    },
    // Mirror of updateUserListLastMessage but for groups
    updateGroupListLastMessage(groupId, { text, is_me, status, timestamp }) {
      const group = this.groupsList.find(g => g.id === groupId);
      if (group) {
        this.$set(group, 'lastMessage', {
          text,
          is_me,
          status,
          timestamp: timestamp || new Date().toISOString()
        });
        // Increment unread badge only for messages from others, not yet read
        if (!is_me && status !== "read") {
          group.unreadCount = (group.unreadCount || 0) + 1;
        }
        // If this group is currently open → no unread badge
        if (this.activeConversation && this.activeConversation.id === groupId) {
          group.unreadCount = 0;
        }
        this.sortGroupsByTime();
      }
    },
    // 🔹 Send a message (works for both 1-on-1 and group chats)
    sendMessage() {
      if (!this.newMessage || !this.activeConversation || !this.channel) return;
      const tempId = Date.now();

      // Build payload differently for groups vs 1-on-1
      const payload = {
        content: this.newMessage,
        entity_id: this.entity_id,
        temp_id: tempId,
        is_group: this.activeConversation.isGroup || false
      };

      // For 1-on-1 chats: add receiver_id
      // For group chats: no receiver_id (message goes to all participants)
      if (!this.activeConversation.isGroup) {
        payload.receiver_id = this.activeConversation.id;
      }

      console.log("Sending message with payload:", payload);
      sendMessage(this.channel, payload);
      // if (this.globalChannel) {
      //     this.globalChannel.push("new_message", payload);
      //   }
      const msg = {
        id: tempId,
        from: "me",
        text: this.newMessage,
        timestamp: new Date().toISOString(),
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        status: "sent" // optimistic update,
      };
      if (!this.messages[this.activeConversation.id]) {
        this.$set(this.messages, this.activeConversation.id, []);
      }
      // Add message to UI optimistically
      this.messages[this.activeConversation.id].push(msg);

      if (this.activeConversation.isGroup) {
        this.updateGroupListLastMessage(this.activeConversation.id, {
          text: this.newMessage,
          is_me: true,
          status: "sent",
          timestamp: new Date().toISOString()
        });
      } else {
        this.updateUserListLastMessage(this.activeConversation.id, {
          text: this.newMessage,
          is_me: true,
          status: "sent",
          timestamp: new Date().toISOString()
        });
      }
      this.newMessage = "";
      this.scrollToBottom();
    },
    closeChat() {
      if (this.activeConversation) {
        // ✅ Clear messages of the active user
        delete this.messages[this.activeConversation.id];
        this.activeConversation = null;
      }
      if (this.channel) {
        this.channel.leave();
        this.channel = null;
      }
    },

    closewindow() {
      this.showChat = false;
      // ✅ Navigate safely
      if (this.$route.path !== "/") {   // 👈 change "/" to where you want to go
        this.$router.push("/").catch(err => {
          if (err.name !== "NavigationDuplicated") throw err;
        });
      }
    }
    ,
    sendTyping() {
      if (!this.channel) return;
      this.channel.push("typing", { typing: true });
      // stop typing after 2s idle
      clearTimeout(this.typingTimeout);
      this.typingTimeout = setTimeout(() => {
        this.channel.push("typing", { typing: false });
      }, 2000);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesArea;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    // Voice recording methods
    async startVoiceRecording() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        // Determine the best supported audio format for cross-browser compatibility
        let options = { mimeType: 'audio/webm;codecs=opus' };

        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
          console.log('audio/webm;codecs=opus not supported, trying alternatives...');

          // Try different formats in order of preference
          const formats = [
            'audio/webm',
            'audio/mp4',
            'audio/ogg;codecs=opus',
            'audio/wav'
          ];

          for (const format of formats) {
            if (MediaRecorder.isTypeSupported(format)) {
              options = { mimeType: format };
              console.log('Using audio format:', format);
              break;
            }
          }

          // If nothing is supported, use default (no options)
          if (!MediaRecorder.isTypeSupported(options.mimeType)) {
            console.log('Using default MediaRecorder format');
            options = {};
          }
        }

        this.mediaRecorder = new MediaRecorder(stream, options);
        this.audioChunks = [];
        this.recordingTime = 0;
        this.recordingMimeType = this.mediaRecorder.mimeType; // Store the actual MIME type used

        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data);
        };

        this.mediaRecorder.onstop = () => {
          const audioBlob = new Blob(this.audioChunks, { type: this.recordingMimeType });
          this.sendVoiceMessage(audioBlob);
          stream.getTracks().forEach(track => track.stop());
        };

        this.mediaRecorder.start();
        this.isRecording = true;

        // Start timer
        this.recordingTimer = setInterval(() => {
          this.recordingTime++;
        }, 1000);
      } catch (error) {
        console.error("Error accessing microphone:", error);
        alert("Could not access microphone. Please check permissions.");
      }
    },
    stopVoiceRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
        clearInterval(this.recordingTimer);
        this.recordingTime = 0;
      }
    },
    cancelVoiceRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
        clearInterval(this.recordingTimer);
        this.recordingTime = 0;
        this.audioChunks = [];
        // Stop all tracks
        if (this.mediaRecorder.stream) {
          this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
        }
      }
    },
    async sendVoiceMessage(audioBlob) {
      if (!this.activeConversation || !this.channel) return;

      const tempId = Date.now();
      const duration = this.recordingTime;

      try {
        // Determine file extension based on MIME type
        const mimeType = audioBlob.type || this.recordingMimeType || 'audio/webm';
        let extension = 'webm';
        if (mimeType.includes('mp4') || mimeType.includes('m4a')) {
          extension = 'm4a';
        } else if (mimeType.includes('ogg')) {
          extension = 'ogg';
        } else if (mimeType.includes('wav')) {
          extension = 'wav';
        }

        // Create a File object from the blob with proper extension and MIME type
        const audioFile = new File([audioBlob], `voice_${tempId}.${extension}`, { type: mimeType });

        console.log("🎙️ Uploading voice message using presigned URL...", audioFile.name, audioFile.type, audioFile.size);

        // Step 1: Get presigned URL from server
        const presignedResponse = await axios.post('generate_presigned_url', {
          file_name: audioFile.name,
          file_type: audioFile.type
        });

        if (presignedResponse.data.status !== 'success') {
          throw new Error('Failed to get presigned URL for voice message');
        }

        const { upload_url, file_url } = presignedResponse.data;

        // Step 2: Upload directly to S3 using presigned URL
        const s3Response = await fetch(upload_url, {
          method: 'PUT',
          body: audioFile,
          headers: {
            'Content-Type': audioFile.type
          }
        });

        if (!s3Response.ok) {
          throw new Error(`Voice message S3 upload failed: ${s3Response.status} ${s3Response.statusText}`);
        }

        const voiceUrl = file_url;
        console.log("✅ Voice message uploaded directly to S3:", voiceUrl);

        // Step 2: Send message with S3 URL (handles both 1-on-1 and groups)
        const payload = {
          content: "[Voice Message]",
          entity_id: this.entity_id,
          temp_id: tempId,
          voice_data: voiceUrl,  // S3 URL instead of base64
          is_voice: true,
          duration: duration,
          is_group: this.activeConversation.isGroup || false
        };

        // For 1-on-1: add receiver_id, For groups: no receiver_id
        if (!this.activeConversation.isGroup) {
          payload.receiver_id = this.activeConversation.id;
        }

        console.log("Sending voice message with S3 URL");
        sendMessage(this.channel, payload);

        // Step 3: Add to UI optimistically with S3 URL
        const msg = {
          id: tempId,
          from: "me",
          text: "[Voice Message]",
          timestamp: new Date().toISOString(),
          time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          status: "sent",
          is_voice: true,
          voice_data: voiceUrl,  // S3 URL instead of base64
          duration: duration
        };

        if (!this.messages[this.activeConversation.id]) {
          this.$set(this.messages, this.activeConversation.id, []);
        }
        this.messages[this.activeConversation.id].push(msg);

        if (this.activeConversation.isGroup) {
          this.updateGroupListLastMessage(this.activeConversation.id, {
            text: "🎤 Voice Message",
            is_me: true,
            status: "delivered",
            timestamp: new Date().toISOString()
          });
        } else {
          this.updateUserListLastMessage(this.activeConversation.id, {
            text: "🎤 Voice Message",
            is_me: true,
            status: "delivered",
            timestamp: new Date().toISOString()
          });
        }

        this.scrollToBottom();
      } catch (error) {
        console.error("❌ Error uploading voice message:", error);
        alert("Failed to send voice message. Please try again.");
      }
    },
    handleSendButtonClick() {
      if (this.newMessage.trim()) {
        this.sendMessage();
      } else if (!this.isRecording) {
        this.startVoiceRecording();
      } else {
        this.stopVoiceRecording();
      }
    },
    formatRecordingTime() {
      const minutes = Math.floor(this.recordingTime / 60);
      const seconds = this.recordingTime % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    },
    formatDuration(seconds) {
      if (!seconds) return "0:00";
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },
    // WhatsApp-style date/time formatting
    formatMessageTime(timestamp) {
      if (!timestamp) return '';
      try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '';

        const hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const displayHours = hours % 12 || 12;
        const displayMinutes = minutes.toString().padStart(2, '0');

        return `${displayHours}:${displayMinutes} ${ampm}`;
      } catch (error) {
        console.error('Error formatting time:', error);
        return '';
      }
    },
    formatSidebarTime(timestamp) {
      if (!timestamp) return '';
      try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '';

        const messageDate = new Date(date).setHours(0, 0, 0, 0);
        const today = new Date().setHours(0, 0, 0, 0);
        const yesterday = new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0);

        if (messageDate === today) {
          // Today - show time only
          const hours = date.getHours();
          const minutes = date.getMinutes();
          const ampm = hours >= 12 ? 'PM' : 'AM';
          const displayHours = hours % 12 || 12;
          const displayMinutes = minutes.toString().padStart(2, '0');
          return `${displayHours}:${displayMinutes} ${ampm}`;
        } else if (messageDate === yesterday) {
          return 'Yesterday';
        } else if (date.getFullYear() === new Date().getFullYear()) {
          // This year - show date without year
          return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        } else {
          // Different year - show full date
          return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        }
      } catch (error) {
        console.error('Error formatting sidebar time:', error);
        return '';
      }
    },
    sortConversationsByTime() {
      // Sort usersList by most recent message (descending)
      this.usersList.sort((a, b) => {
        // Convert timestamps to Date objects for proper comparison
        const timeA = a.lastMessage?.timestamp ? new Date(a.lastMessage.timestamp).getTime() : 0;
        const timeB = b.lastMessage?.timestamp ? new Date(b.lastMessage.timestamp).getTime() : 0;
        return timeB - timeA; // Most recent first (users without messages go to bottom)
      });
    },
    sortGroupsByTime() {
      this.groupsList.sort((a, b) => {
        const timeA = a.lastMessage?.timestamp ? new Date(a.lastMessage.timestamp).getTime() : 0;
        const timeB = b.lastMessage?.timestamp ? new Date(b.lastMessage.timestamp).getTime() : 0;
        return timeB - timeA;
      });
    },
    addEmoji(emoji) {
      this.newMessage += emoji;
    },
    playVoiceMessage(msg) {
      if (!msg.voice_data) {
        console.error("No voice data available");
        return;
      }

      // If this message is already playing, pause it
      if (this.currentlyPlayingId === msg.id && this.audioPlayer && !this.audioPlayer.paused) {
        this.audioPlayer.pause();
        this.currentlyPlayingId = null;
        return;
      }

      // Stop any currently playing audio
      if (this.audioPlayer) {
        this.audioPlayer.pause();
        this.audioPlayer.currentTime = 0;
      }

      try {
        // Create new audio element with better error handling
        this.audioPlayer = new Audio();

        // Set CORS if needed (for S3 URLs)
        this.audioPlayer.crossOrigin = "anonymous";

        // Add event listeners
        this.audioPlayer.onloadstart = () => {
          console.log("🎵 Loading voice message...");
          this.currentlyPlayingId = msg.id;
        };

        this.audioPlayer.oncanplay = () => {
          console.log("✅ Voice message ready to play");
        };

        this.audioPlayer.onended = () => {
          console.log("🎵 Voice message finished playing");
          this.currentlyPlayingId = null;
        };

        this.audioPlayer.onerror = (error) => {
          console.error("❌ Error playing voice message:", error);
          console.error("Audio error details:", {
            error: this.audioPlayer.error,
            networkState: this.audioPlayer.networkState,
            readyState: this.audioPlayer.readyState,
            src: this.audioPlayer.src
          });

          this.currentlyPlayingId = null;

          // Provide user-friendly error message
          let errorMessage = "Unable to play voice message. ";
          if (this.audioPlayer.error) {
            switch (this.audioPlayer.error.code) {
              case 1: // MEDIA_ERR_ABORTED
                errorMessage += "Playback was aborted.";
                break;
              case 2: // MEDIA_ERR_NETWORK
                errorMessage += "Network error occurred.";
                break;
              case 3: // MEDIA_ERR_DECODE
                errorMessage += "Audio format not supported.";
                break;
              case 4: // MEDIA_ERR_SRC_NOT_SUPPORTED
                errorMessage += "Audio source not supported. The file may be corrupted or in an unsupported format.";
                break;
              default:
                errorMessage += "Unknown error occurred.";
            }
          }

          alert(errorMessage);
        };

        // Set the source and play
        this.audioPlayer.src = msg.voice_data;
        this.audioPlayer.load(); // Explicitly load the audio

        // Attempt to play
        const playPromise = this.audioPlayer.play();

        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log("🎵 Voice message playing successfully");
            })
            .catch(err => {
              console.error("❌ Playback failed:", err);
              this.currentlyPlayingId = null;

              if (err.name === 'NotSupportedError') {
                alert("This audio format is not supported by your browser. Please try using a different browser.");
              } else if (err.name === 'NotAllowedError') {
                alert("Playback was prevented. Please interact with the page first.");
              } else {
                alert("Failed to play voice message: " + err.message);
              }
            });
        }
      } catch (error) {
        console.error("❌ Exception while trying to play voice message:", error);
        this.currentlyPlayingId = null;
        alert("An error occurred while trying to play the voice message.");
      }
    },
    // Attachment handlers
    openGallery() {
      this.$refs.galleryInput.click();
    },
    openDocuments() {
      this.$refs.documentInput.click();
    },
    handleGalleryUpload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        this.pendingAttachmentType = 'gallery';
        this.previewFiles(Array.from(files));
        // Reset input
        event.target.value = '';
      }
    },
    handleDocumentUpload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        this.pendingAttachmentType = 'document';
        this.previewFiles(Array.from(files));
        // Reset input
        event.target.value = '';
      }
    },
    previewFiles(files) {
      files.forEach(file => {
        // Check file size (max 50MB)
        const maxSize = 50 * 1024 * 1024; // 50MB
        if (file.size > maxSize) {
          alert(`File "${file.name}" is too large. Maximum size is 50MB.`);
          return;
        }

        this.pendingFiles.push(file);

        // Create preview
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.pendingFilesPreview.push({
            name: file.name,
            type: file.type,
            size: file.size,
            preview: reader.result
          });
        };
      });
    },
    removePendingFile(index) {
      this.pendingFiles.splice(index, 1);
      this.pendingFilesPreview.splice(index, 1);
      if (this.pendingFiles.length === 0) {
        this.pendingAttachmentType = null;
        this.newMessage = '';
      }
    },
    sendPendingFiles() {
      if (this.pendingFiles.length === 0) return;

      this.pendingFiles.forEach(file => {
        this.uploadFile(file, this.pendingAttachmentType);
      });

      // Clear pending files
      this.pendingFiles = [];
      this.pendingFilesPreview = [];
      this.pendingAttachmentType = null;
      this.newMessage = '';
    },
    async uploadFile(file, type) {
      if (!this.activeConversation || !this.channel) return;

      // Check file size (max 50MB)
      const maxSize = 50 * 1024 * 1024; // 50MB
      if (file.size > maxSize) {
        alert(`File "${file.name}" is too large. Maximum size is 50MB.`);
        return;
      }

      const tempId = Date.now() + Math.random(); // Unique temp ID

      try {
        let fileUrl;

        // Use presigned URL approach for ALL file types (images, videos, documents)
        console.log("📤 Uploading file using presigned URL:", file.name, file.type, file.size);

        // Step 1: Get presigned URL from server
        const presignedResponse = await axios.post('generate_presigned_url', {
          file_name: file.name,
          file_type: file.type
        });

        if (presignedResponse.data.status !== 'success') {
          throw new Error('Failed to get presigned URL');
        }

        const { upload_url, file_url } = presignedResponse.data;

        // Step 2: Upload directly to S3 using presigned URL
        // Use fetch instead of axios to bypass baseURL configuration
        const s3Response = await fetch(upload_url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type
          }
        });

        if (!s3Response.ok) {
          throw new Error(`S3 upload failed: ${s3Response.status} ${s3Response.statusText}`);
        }

        fileUrl = file_url;
        console.log("✅ File uploaded directly to S3:", fileUrl);

        // Step 2: Send message with S3 URL (handles both 1-on-1 and groups)
        const payload = {
          content: file.name,
          entity_id: this.entity_id,
          temp_id: tempId,
          file_data: fileUrl,  // S3 URL instead of base64
          file_name: file.name,
          file_type: file.type,
          file_size: file.size,
          is_file: true,
          attachment_type: type, // 'gallery' or 'document'
          is_group: this.activeConversation.isGroup || false
        };

        // For 1-on-1: add receiver_id, For groups: no receiver_id
        if (!this.activeConversation.isGroup) {
          payload.receiver_id = this.activeConversation.id;
        }

        console.log("Sending message with S3 URL");
        sendMessage(this.channel, payload);

        // Step 3: Add to UI optimistically with S3 URL
        const msg = {
          id: tempId,
          from: "me",
          text: file.name,
          timestamp: new Date().toISOString(),
          time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          status: "sent",
          is_file: true,
          file_name: file.name,
          file_type: file.type,
          file_data: fileUrl,  // S3 URL instead of base64
          file_size: file.size,
          attachment_type: type
        };

        if (!this.messages[this.activeConversation.id]) {
          this.$set(this.messages, this.activeConversation.id, []);
        }
        this.messages[this.activeConversation.id].push(msg);

        const sidebarText = file.type.startsWith('image/') ? '📷 Photo'
          : file.type.startsWith('video/') ? '🎥 Video'
          : `📎 ${file.name}`;
        if (this.activeConversation.isGroup) {
          this.updateGroupListLastMessage(this.activeConversation.id, {
            text: sidebarText,
            is_me: true,
            status: "delivered",
            timestamp: new Date().toISOString()
          });
        } else {
          this.updateUserListLastMessage(this.activeConversation.id, {
            text: sidebarText,
            is_me: true,
            status: "delivered",
            timestamp: new Date().toISOString()
          });
        }

        this.scrollToBottom();
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("Failed to upload file. Please try again.");
      }
    },
    linkifyText(text) {
      if (!text) return '';
      // Escape HTML first to prevent XSS
      const escaped = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
      // Convert URLs to clickable links
      const urlPattern = /(https?:\/\/[^\s<]+)/g;
      return escaped.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: inherit; text-decoration: underline;">$1</a>');
    },
    openImageViewer(imageUrl, title) {
      this.imageViewerUrl = imageUrl || null;
      this.imageViewerTitle = title || '';
      this.showImageViewerDialog = true;
    },
    async uploadGroupPic(event) {
      const file = event.target.files[0];
      if (!file || !this.activeConversation?.isGroup) return;

      // Reset input so same file can be re-selected
      event.target.value = '';

      // Validate file type and size
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file.');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        alert('Image is too large. Maximum size is 5MB.');
        return;
      }

      try {
        // Step 1: Get presigned URL
        const presignedResponse = await axios.post('generate_presigned_url', {
          file_name: file.name,
          file_type: file.type
        });

        if (presignedResponse.data.status !== 'success') {
          throw new Error('Failed to get presigned URL');
        }

        const { upload_url, file_url } = presignedResponse.data;

        // Step 2: Upload to S3
        const s3Response = await fetch(upload_url, {
          method: 'PUT',
          body: file,
          headers: { 'Content-Type': file.type }
        });

        if (!s3Response.ok) {
          throw new Error('S3 upload failed');
        }

        // Step 3: Save group_pic URL to DB
        const roomId = this.activeConversation.room_id || this.activeConversation.id;
        await axios.put(`/chat_rooms/${roomId}/update_group_pic`, {
          group_pic: file_url,
          user_id: this.logged_user_id
        });

        // Step 4: Update local state
        this.activeConversation.group_pic = file_url;

        // Also update in groupsList
        const groupIndex = this.groupsList.findIndex(g => g.id === this.activeConversation.id || g.room_id === roomId);
        if (groupIndex !== -1) {
          this.$set(this.groupsList[groupIndex], 'group_pic', file_url);
        }

        console.log("Group picture updated successfully:", file_url);
      } catch (error) {
        console.error("Error uploading group picture:", error);
        alert("Failed to upload group picture. Please try again.");
      }
    },
    // File helper methods
    getFileIcon(fileName) {
      const ext = fileName.split('.').pop().toLowerCase();
      const iconMap = {
        pdf: 'mdi-file-pdf-box',
        doc: 'mdi-file-word',
        docx: 'mdi-file-word',
        xls: 'mdi-file-excel',
        xlsx: 'mdi-file-excel',
        ppt: 'mdi-file-powerpoint',
        pptx: 'mdi-file-powerpoint',
        txt: 'mdi-file-document-outline',
        zip: 'mdi-folder-zip',
        rar: 'mdi-folder-zip',
        mp3: 'mdi-file-music',
        wav: 'mdi-file-music',
      };
      return iconMap[ext] || 'mdi-file';
    },
    formatFileSize(bytes) {
      if (!bytes) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    },
    async downloadFile(msg) {
      try {
        // Fetch the file from the URL
        const response = await fetch(msg.file_data);
        if (!response.ok) throw new Error('Download failed');
        
        // Convert to blob
        const blob = await response.blob();
        
        // Create blob URL
        const blobUrl = window.URL.createObjectURL(blob);
        
        // Create download link
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = msg.file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Clean up blob URL
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('File download error:', error);
        // Fallback: open in new tab
        window.open(msg.file_data, '_blank');
      }
    },
    openImageFullScreen(imageData) {
      window.open(imageData, '_blank');
    },
    // Delete message - Show WhatsApp-style confirmation dialog
    deleteMessage(msg) {
      this.messageToDelete = msg;
      this.showDeleteDialog = true;
    },
    // Cancel delete
    cancelDelete() {
      this.showDeleteDialog = false;
      this.messageToDelete = null;
    },
    // Confirm delete and make API call
    confirmDelete() {
      if (!this.messageToDelete) return;

      this.deletingMessage = true;
      const msg = this.messageToDelete;

      axios
        .delete(`delete_message/${msg.id}`)
        .then(() => {
          // Remove from UI
          const messageList = this.messages[this.activeConversation.id];
          const index = messageList.findIndex(m => m.id === msg.id);
          if (index !== -1) {
            messageList.splice(index, 1);
          }

          // Update last message in sidebar (group or 1-on-1)
          const updateFn = this.activeConversation.isGroup
            ? this.updateGroupListLastMessage
            : this.updateUserListLastMessage;
          if (messageList.length > 0) {
            const lastMsg = messageList[messageList.length - 1];
            updateFn(this.activeConversation.id, {
              text: lastMsg.text || '[Attachment]',
              is_me: lastMsg.from === 'me',
              status: lastMsg.status
            });
          } else {
            updateFn(this.activeConversation.id, {
              text: '',
              is_me: false,
              status: ''
            });
          }

          // Close dialog and reset
          this.deletingMessage = false;
          this.showDeleteDialog = false;
          this.messageToDelete = null;
        })
        .catch(err => {
          console.error("Error deleting message:", err);
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to delete message. Please try again.',
            life: 3000
          });
          this.deletingMessage = false;
          this.showDeleteDialog = false;
          this.messageToDelete = null;
        });
    },
    // Groups methods - Using Forums API Logic
    getGroupMemberCount(groupId) {
      const group = this.groupsList.find(g => g.id === groupId);
      return group ? group.memberCount : 0;
    },
    // Get actual Family Office member count for active conversation
    async getActiveMemberCount() {
      if (!this.activeConversation || !this.activeConversation.isGroup) return 0;

      try {
        const response = await axios.get(`/get_users_by_forum_with_office`, {
          params: {
            forum_id: this.activeConversation.id,
            entity_id: this.entity_id
          }
        });

        const familyOfficeUsers = response.data.data || [];
        const uniqueUserIds = new Set();

        familyOfficeUsers.forEach(user => {
          if (user.user_id) {
            uniqueUserIds.add(user.user_id);
          }
        });

        return uniqueUserIds.size;
      } catch (error) {
        console.error(" Error fetching active member count:", error);
        return 0;
      }
    },
    async searchGroups() {
      this.loader_check = true;
      const searchQuery = this.searchQuery || "";

      try {
        let allGroups = [];
        let memberCountMap = {};

        //  Fetch custom group chat rooms
        try {
          console.log("🔍 Fetching custom groups with params:", {
            entity_id: this.entity_id,
            user_id: this.logged_user_id
          });

          const customGroupsResponse = await axios.get("/chat_rooms", {
            params: {
              entity_id: this.entity_id,
              user_id: this.logged_user_id
            }
          });
          const customGroups = customGroupsResponse.data.data || [];

          console.log(" Raw custom groups response:", customGroups);
          console.log(" Total rooms returned:", customGroups.length);

          // Filter only group type chat rooms (not private) and for current entity
          //  Fixed: Convert both to numbers to handle type mismatch
          const groupChatRooms = customGroups
            .filter(room => {
              const isGroup = room.type === "group";
              const matchesEntity = Number(room.entity_id) === Number(this.entity_id);
              const passes = isGroup && matchesEntity && room.is_manual_group;


              return passes;
            })
            .map(room => ({
              id: room.id,
              name: room.name || "Unnamed Group",
              room_id: room.id,
              is_custom_group: true,  // Mark as custom group
              is_sub_positions: false,  // Not a board position
              creator_id: room.creator_id,  // Store creator/admin ID
              group_pic: room.group_pic || null  // Group profile picture
            }));

          console.log(" Filtered custom group chat rooms:", groupChatRooms.length);
          if (groupChatRooms.length > 0) {
            console.log(" Custom groups:", groupChatRooms.map(g => g.name));
            console.log("🔑 Creator IDs:", groupChatRooms.map(g => ({ name: g.name, creator_id: g.creator_id })));
          } else {
            console.warn(" No custom groups found after filtering!");
          }

          //  Fetch member counts for custom groups using chat_room_participants API
          for (const group of groupChatRooms) {
            try {
              const response = await axios.get(`/chat_room_participants`, {
                params: {
                  chat_room_id: group.id
                }
              });
              const participants = response.data.data || [];

              // Count participants (each participant is a member)
              memberCountMap[group.id] = participants.length;
              console.log(`👥 Custom group "${group.name}" has ${participants.length} members`);
            } catch (error) {
              console.error(` Could not fetch member count for group ${group.id}:`, error);
              memberCountMap[group.id] = 0;
            }
          }

          allGroups = [...groupChatRooms];  // Start with custom groups
        } catch (error) {
          console.error(" Error fetching custom groups:", error);
        }

        if (this.isFamilyBook) {
          // Family Book users: Use Forums APIs
          console.log(" Fetching groups for Family Book user (Forums)");

          const boardTypesResponse = await axios.post("/list_of_board_types", {
            is_active: [true]
          });

          const board_types_DataSet = boardTypesResponse.data.data || [];
          const forumsType = board_types_DataSet.find(x => x.name === "Forum");
          const board_types_id = forumsType ? forumsType.id : null;

          const forumsResponse = await axios.post("/to_landing_forums_units", {
            board_types_ids: board_types_id ? [board_types_id] : "~~nodata~~",
            entity_id: this.entity_id
          });

          const forumGroups = forumsResponse.data.data || [];
          allGroups = [...allGroups, ...forumGroups];  // Merge with custom groups
          const forumMemberCounts = await this.fetchMemberCountsForAllForums(forumGroups, true);
          memberCountMap = { ...memberCountMap, ...forumMemberCounts };  // Merge custom and forum counts

        } else if (this.isBoardPage) {
          // Board members: Use Board Units APIs
          console.log(" Fetching groups for Board member (Board Units)");

          const boardUnitsResponse = await axios.post("/to_landing_board_units", {
            entity_id: this.entity_id
          });

          const subboardUnitsResponse = await axios.post("/to_landing_subboard_units", {
            entity_id: this.entity_id
          });

          const boardUnits = boardUnitsResponse.data.data || [];
          const subboardUnits = subboardUnitsResponse.data.data || [];

          // Combine board units and subboard units with custom groups
          const boardGroups = [...boardUnits, ...subboardUnits];
          allGroups = [...allGroups, ...boardGroups];  // Merge with custom groups
          const boardMemberCounts = await this.fetchMemberCountsForAllForums(boardGroups, false);
          memberCountMap = { ...memberCountMap, ...boardMemberCounts };  // Merge custom and board counts

        } else {
          // Regular STARR users: Implementation to be added later
          console.log("⭐ Regular STARR user - Group API implementation pending");
          // TODO: Add appropriate API calls for STARR users here
        }

        //  Store existing groups before updating to preserve member info
        const existingGroupsMap = new Map();
        this.groupsList.forEach(g => {
          existingGroupsMap.set(g.id, g);
        });

        this.groupsList = allGroups
          .filter((group) => {
            //  IMPORTANT: Only show forums where is_sub_positions is FALSE
            // is_sub_positions: true = Board positions (Head, Senior teachers) - EXCLUDE
            // is_sub_positions: false = Actual group chats (CHATS, Private Messages) - INCLUDE
            if (group.is_sub_positions === true) {
              console.log(" Excluding board position:", group.name);
              return false;
            }

            // Filter by search query if provided
            if (searchQuery) {
              return group.name.toLowerCase().includes(searchQuery.toLowerCase());
            }
            return true;
          })
          .map((group) => {
            //  Check if this group already exists and has stored members
            const existingGroup = existingGroupsMap.get(group.id);

            return {
              id: group.id,
              group_name: group.name,
              memberCount: memberCountMap[group.id] || 0, //  Works for both custom and forum groups
              lastMessage: null,
              unreadCount: 0,
              //  Preserve custom group properties
              room_id: group.room_id || null,
              is_custom_group: group.is_custom_group || false,
              creator_id: group.creator_id,  // Preserve creator/admin ID
              group_pic: group.group_pic || null,  // Group profile picture
              //  Preserve stored members if they exist
              members: existingGroup?.members || null
            };
          });

        console.log(" Total groups loaded:", this.groupsList.length);
        console.log(" Custom groups:", this.groupsList.filter(g => g.is_custom_group).length);
        console.log(" Forum/Board groups:", this.groupsList.filter(g => !g.is_custom_group).length);

        this.loader_check = false;

        // Load last message for each group to populate sidebar (like fetchLastMessages for users)
        this.fetchGroupLastMessages();
      } catch (err) {
        console.error(" Error searching groups:", err);
        this.loader_check = false;
      }
    },

    //  Fetch member counts for all groups (forums or board units)
    async fetchMemberCountsForAllForums(groupsData, isFamilyBook) {
      // Initialize member count map with all group IDs set to 0
      const memberCountMap = {};
      groupsData.forEach((group) => {
        memberCountMap[group.id] = 0;
      });

      if (groupsData.length === 0) {
        return memberCountMap;
      }

      try {
        let allUsers = [];
        const groupIdsParam = groupsData.map(g => g.id).join(',');

        if (isFamilyBook) {
          // Family Book users: Use forum API
          console.log(" Fetching Family Office members for", groupsData.length, "forums");
          console.log(" Querying forum IDs:", groupIdsParam);

          const response = await axios.get(`/get_users_by_forum_with_office`, {
            params: {
              forum_id: groupIdsParam,
              entity_id: this.entity_id
            }
          });

          allUsers = response.data.data || [];
          console.log("👥 Family Office users fetched:", allUsers.length);

        } else {
          // Board members: Use board units API (if different endpoint exists)
          console.log(" Fetching Board members for", groupsData.length, "board units");
          console.log(" Querying board unit IDs:", groupIdsParam);

          // TODO: Use appropriate board units member API
          const response = await axios.get(`/get_users_by_board_units`, {
            params: {
              board_unit_id: groupIdsParam,
              entity_id: this.entity_id
            }
          });

          allUsers = response.data.data || [];
          console.log(" Board members fetched:", allUsers.length);
        }

        // Debug: Check what fields are available in the response
        if (allUsers.length > 0) {
          console.log(" Sample user object:", allUsers[0]);
          console.log(" Available fields:", Object.keys(allUsers[0]));
        }

        // Group users by forum using subforum_id
        //  IMPORTANT: Only count users where family_office_flag is true
        const forumUsersMap = {};

        allUsers.forEach(user => {
          const forumId = user.subforum_id || user.sub_forum_id || user.forum_id ||
                          user.sub_board_units_id || user.board_units_id;
          const userId = user.user_id;

          if (!userId) {
            console.warn(" User without user_id:", user);
            return;
          }

          //  Filter: Only include users with family_office_flag: true
          const isFamilyOfficeMember = user.family_office_flag === true;
          if (!isFamilyOfficeMember) {
            console.log(` Skipping user ${user.user_name} (family_office_flag: ${user.family_office_flag})`);
            return;
          }

          if (forumId) {
            if (!forumUsersMap[forumId]) {
              forumUsersMap[forumId] = new Set();
            }
            forumUsersMap[forumId].add(userId);
          } else {
            console.warn(" User without forum association:", user);
          }
        });

        console.log(" Forum users map:", forumUsersMap);

        // Calculate counts from unique user sets
        Object.keys(forumUsersMap).forEach(forumId => {
          const forumIdNum = Number(forumId);
          memberCountMap[forumIdNum] = forumUsersMap[forumId].size;
        });

        console.log(" Family Office member counts calculated:", memberCountMap);
        return memberCountMap;
      } catch (error) {
        console.error(" Error fetching member counts:", error);
        return memberCountMap;
      }
    },
    async selectGroup(group) {
      console.log(" Selected group:", group);

      try {
        // Set active conversation to this group
        this.activeConversation = {
          id: group.id,
          user_name: group.group_name,  // Group name as display name
          isGroup: true,  // Flag to identify it's a group
          group_pic: group.group_pic || null  // Group profile picture
        };

        // Leave previous channel if exists
        if (this.channel) this.channel.leave();

        let roomId;
        let participantIds = [];

        //  Check if this is a custom group (manually created) or forum-based group
        if (group.is_custom_group || group.room_id) {
          console.log(" Opening custom group (manually created)");

          // For custom groups, the room already exists - use the room_id directly
          roomId = group.room_id || group.id;

          // Set member count from group data
          this.activeConversation.memberCount = group.memberCount || 0;
          console.log(` Custom group has ${this.activeConversation.memberCount} members`);

        } else {
          console.log(" Opening forum-based group");

          //  STEP 1: Get all member IDs for this group including Family Office users
          // Fetch Family Office users using the same API as announcements
          const familyOfficeResponse = await axios.get(`/get_users_by_forum_with_office`, {
            params: {
              forum_id: group.id,
              entity_id: this.entity_id
            }
          });

          const familyOfficeUsers = familyOfficeResponse.data.data || [];
          console.log(" Family Office users for group:", familyOfficeUsers.length);

          // Extract unique participant IDs from Family Office users
          const uniqueUserIds = new Set();

          familyOfficeUsers.forEach(user => {
            // Only include users with family_office_flag: true
            if (user.family_office_flag !== true) {
              console.log(` Skipping ${user.user_name} in selectGroup (not Family Office member)`);
              return;
            }

            if (user.user_id && !uniqueUserIds.has(user.user_id)) {
              uniqueUserIds.add(user.user_id);
              participantIds.push(user.user_id);
            }
          });

          // Update active conversation with actual Family Office member count
          this.activeConversation.memberCount = uniqueUserIds.size;
          console.log(` Group has ${uniqueUserIds.size} Family Office members`);


          //  STEP 2: Create/Get group chat room using new GROUP endpoint (only for forum-based groups)
          const roomResponse = await axios.post("group_chat_room_details", {
            participant_ids: participantIds,  //  Array of all member IDs (handled properly by group endpoint)
            user_id: Number(this.logged_user_id),
            entity_id: this.entity_id,
            group_name: group.group_name,
            forum_id: group.id  // UNIQUE forum ID to prevent room collision
          });

          roomId = roomResponse.data.room_id;
          console.log(" Group chat room ID:", roomId);
        }

        //  STEP 3: Join socket room (same as 1-on-1)
        const { channel, presence } = joinRoom(roomId, null, {  // null for otherUserId (it's a group)
          onJoin: (resp) => {
            console.log(" Joined group room:", resp);
          },
          onMessage: (payload) => {
            console.log(" Group message:", payload);

            if (payload.chat_room_id === roomId) {
              if (!this.messages[group.id]) {
                this.$set(this.messages, group.id, []);
              }

              // Handle optimistic message update
              let existingMsg = null;
              if (payload.temp_id) {
                existingMsg = this.messages[group.id].find(m => m.id === payload.temp_id);
              }

              const isMeSender = Number(payload.sender_id) === Number(this.logged_user_id);
              const sidebarDisplayText = payload.is_voice ? "🎤 Voice Message"
                : payload.is_file
                  ? (payload.file_type && payload.file_type.startsWith('image/') ? "📷 Photo"
                    : payload.file_type && payload.file_type.startsWith('video/') ? "🎥 Video"
                    : `📎 ${payload.file_name || 'File'}`)
                  : payload.content;

              if (existingMsg) {
                // Optimistic message confirmed — update id and status
                this.$set(existingMsg, 'id', payload.id);
                this.$set(existingMsg, 'status', 'sent');
                this.$set(existingMsg, 'time', new Date(payload.inserted_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                }));
                // Update sidebar for confirmed send
                this.updateGroupListLastMessage(group.id, {
                  text: sidebarDisplayText,
                  is_me: true,
                  status: "sent",
                  timestamp: this.parseBackendTimestamp(payload.inserted_at)
                });
              } else {
                // New incoming message from another group member
                let resolvedSenderName = payload.sender_name;
                if (!resolvedSenderName) {
                  const senderUser = this.usersList.find(u => Number(u.id) === Number(payload.sender_id));
                  resolvedSenderName = senderUser ? senderUser.user_name : `User ${payload.sender_id}`;
                }
                const msg = {
                  id: payload.id,
                  from: isMeSender ? "me" : "other",
                  text: payload.content,
                  timestamp: payload.inserted_at,
                  time: new Date(payload.inserted_at).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  }),
                  status: "delivered",
                  is_voice: payload.is_voice || false,
                  is_file: payload.is_file || false,
                  file_data: payload.file_data,
                  file_name: payload.file_name,
                  file_type: payload.file_type,
                  file_size: payload.file_size,
                  attachment_type: payload.attachment_type,
                  sender_name: resolvedSenderName,
                  sender_profile_pic: this.getSenderProfilePic(payload.sender_id),
                  seen_by: payload.seen_by || []
                };

                this.messages[group.id].push(msg);
                this.scrollToBottom();

                // Update group sidebar with this new message
                this.updateGroupListLastMessage(group.id, {
                  text: sidebarDisplayText,
                  is_me: isMeSender,
                  status: "delivered",
                  timestamp: this.parseBackendTimestamp(payload.inserted_at)
                });
              }
            }
          },
          onTyping: (payload) => {
            if (payload.user_id !== Number(this.logged_user_id)) {
              this.isOtherUserTyping = payload.typing;
            }
          },
          onError: (err) => console.error(" Group room error:", err)
        });

        this.channel = channel;
        this.presence = presence;

        // Setup typing indicator
        this.channel.on("typing", (payload) => {
          if (payload.user_id !== Number(this.logged_user_id)) {
            this.isOtherUserTyping = payload.typing;
          }
        });

        // Listen for real-time seen receipts from group members
        this.channel.on("group:seen", (payload) => {
          if (!this.messages[group.id]) return;
          const seenEntry = { user_id: payload.user_id, name: payload.user_name };
          (payload.message_ids || []).forEach(msgId => {
            const msg = this.messages[group.id].find(m => m.id === msgId);
            if (msg) {
              const already = (msg.seen_by || []).some(s => s.user_id === payload.user_id);
              if (!already) {
                const updatedSeenBy = [...(msg.seen_by || []), seenEntry];
                this.$set(msg, 'seen_by', updatedSeenBy);
              }
            }
          });
        });

        //  STEP 4: Load past group messages using NEW group-specific endpoint
        console.log(" Loading group messages for room:", roomId);
        const messagesResponse = await axios.get(
          `group_messages?chatroom_id=${roomId}&entity_id=${this.entity_id}`
        );

        console.log(" Group messages response:", messagesResponse.data);

        // Clear existing messages to avoid duplicates when reopening
        this.$set(this.messages, group.id, []);

        if (messagesResponse.data && messagesResponse.data.data && messagesResponse.data.data.length > 0) {
          messagesResponse.data.data.forEach((v) => {
            // Fallback: if sender_name not in DB (old messages), look up from usersList
            let resolvedSenderName = v.sender_name;
            if (!resolvedSenderName) {
              const senderUser = this.usersList.find(u => Number(u.id) === Number(v.sender_id));
              resolvedSenderName = senderUser ? senderUser.user_name : `User ${v.sender_id}`;
            }
            this.messages[group.id].push({
              id: v.id,
              from: Number(v.sender_id) === Number(this.logged_user_id) ? "me" : "other",
              text: v.content,
              timestamp: v.inserted_at,
              time: new Date(v.inserted_at).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              status: v.status,
              is_voice: v.is_voice || false,
              is_file: v.is_file || false,
              file_data: v.file_data,
              file_name: v.file_name,
              file_type: v.file_type,
              file_size: v.file_size,
              attachment_type: v.attachment_type,
              sender_name: resolvedSenderName,
              sender_profile_pic: this.getSenderProfilePic(v.sender_id),
              seen_by: v.seen_by || []
            });
          });
          console.log(` Loaded ${messagesResponse.data.data.length} group messages`);

          // Update group sidebar with last message from history
          const lastMsg = messagesResponse.data.data[messagesResponse.data.data.length - 1];
          const displayText = lastMsg.is_voice ? "🎤 Voice Message"
            : lastMsg.is_file
              ? (lastMsg.file_type && lastMsg.file_type.startsWith('image/') ? "📷 Photo"
                : lastMsg.file_type && lastMsg.file_type.startsWith('video/') ? "🎥 Video"
                : `📎 ${lastMsg.file_name || 'File'}`)
              : lastMsg.content;
          this.updateGroupListLastMessage(group.id, {
            text: displayText,
            is_me: Number(lastMsg.sender_id) === Number(this.logged_user_id),
            status: lastMsg.status || "sent",
            timestamp: this.parseBackendTimestamp(lastMsg.inserted_at)
          });

          // Reset unread badge now that user has opened and seen the messages
          const grp = this.groupsList.find(g => g.id === group.id);
          if (grp) grp.unreadCount = 0;
        } else {
          console.log(" No messages found for this group");
        }

        // Mark all group messages as seen by this user
        const meUser = this.usersList.find(u => u.is_me);
        const myName = (meUser && meUser.user_name) || `User ${this.logged_user_id}`;
        axios.post('mark_group_seen', {
          chat_room_id: roomId,
          user_id: Number(this.logged_user_id),
          user_name: myName
        }).catch(() => {});

        this.$nextTick(() => {
          this.scrollToBottom();
        });
        console.log(" Group chat opened successfully!");

      } catch (error) {
        console.error(" Error opening group chat:", error);
        alert("Failed to open group chat. Please try again.");
      }
    },
    // Show group members list
    async showGroupMembers() {
      if (!this.activeConversation || !this.activeConversation.isGroup) return;

      try {
        console.log(" Fetching members for group:", this.activeConversation.user_name);
        console.log(" Group ID:", this.activeConversation.id);

        const currentGroup = this.groupsList.find(g => g.id === this.activeConversation.id);
        //  First, try to use stored members (for custom groups)
        if (currentGroup?.is_custom_group && currentGroup?.members && currentGroup.members.length > 0) {
          console.log("👥 Using stored members for custom group:", currentGroup.members.length);

          this.groupMembers = currentGroup.members.map(member => ({
            name: member.user_name || "Unknown",
            position: member.email || "",
            user_id: member.user_id,
            isYou: member.isYou || member.user_id == this.logged_user_id,
            isAdmin: currentGroup.creator_id && Number(member.user_id) === Number(currentGroup.creator_id)
          }));

          //  Ensure creator/admin is always in the stored members list
          if (currentGroup.creator_id) {
            const creatorInList = this.groupMembers.some(m => Number(m.user_id) === Number(currentGroup.creator_id));
            if (!creatorInList) {
              const creatorUser = this.usersList.find(u => Number(u.id) === Number(currentGroup.creator_id));
              const creatorFromMembers = currentGroup.members?.find(m => Number(m.user_id) === Number(currentGroup.creator_id));
              const creatorName = creatorUser ? creatorUser.user_name.replace(' (You)', '') : (creatorFromMembers?.user_name || 'Unknown User');
              console.log("👥 Creator missing from stored members, adding:", creatorName);
              this.groupMembers.unshift({
                name: creatorName,
                position: creatorUser?.email || creatorUser?.designation || "",
                user_id: Number(currentGroup.creator_id),
                isYou: Number(currentGroup.creator_id) === Number(this.logged_user_id),
                isAdmin: true
              });
            }
          }

          //  Sort: Admin first, then You, then others
          this.groupMembers.sort((a, b) => {
            if (a.isAdmin && !b.isAdmin) return -1;
            if (!a.isAdmin && b.isAdmin) return 1;
            if (a.isYou && !b.isYou) return -1;
            if (!a.isYou && b.isYou) return 1;
            return 0;
          });

          console.log(` Displaying ${this.groupMembers.length} stored members`);
          this.showMembersDialog = true;
          return;
        }

        //  Fallback: Use API - different endpoints for custom vs forum groups
        let users = [];

        if (currentGroup?.is_custom_group) {
          // For manual/custom groups: Fetch from chat_room_participants
          console.log(" Fetching participants from chat_room_participants");
          const participantsResponse = await axios.get(`/chat_room_participants`, {
            params: {
              chat_room_id: this.activeConversation.id
            }
          });

          const participantIds = participantsResponse.data.data || [];
          console.log("👥 Fetched participant IDs:", participantIds);

          // Ensure current user AND creator are always included
          const idsToInclude = [Number(this.logged_user_id)];
          if (currentGroup.creator_id) {
            idsToInclude.push(Number(currentGroup.creator_id));
          }
          const allParticipantIds = [...new Set([...participantIds, ...idsToInclude])];
          // Map participant IDs to user details from usersList
          users = allParticipantIds.map(userId => {
            const user = this.usersList.find(u => Number(u.id) === Number(userId));
            console.log(`👥 Looking for userId ${userId}, found:`, user ? user.user_name : 'NOT FOUND');
            if (user) {
              return {
                user_id: user.id,
                user_name: user.user_name.replace(' (You)', ''), // Remove (You) suffix
                email: user.email,
                family_office_flag: true, // Assume all participants are valid
                isAdmin: currentGroup.creator_id && Number(user.id) === Number(currentGroup.creator_id)
              };
            }
            // If user not found in usersList but it's the current user, add them anyway
            if (Number(userId) === Number(this.logged_user_id)) {
              console.log("👥 Adding current user manually");
              const currentUserFromList = this.usersList.find(u => Number(u.id) === Number(this.logged_user_id));
              const actualUserName = currentUserFromList ? currentUserFromList.user_name.replace(' (You)', '') : 'Unknown User';
              return {
                user_id: Number(this.logged_user_id),
                user_name: actualUserName,
                email: currentUserFromList?.email || "",
                family_office_flag: true,
                isAdmin: currentGroup.creator_id && Number(this.logged_user_id) === Number(currentGroup.creator_id)
              };
            }
            // If user not found in usersList but it's the creator, add them with fallback info
            if (currentGroup.creator_id && Number(userId) === Number(currentGroup.creator_id)) {
              // Try to get actual name from stored group members
              const storedMember = currentGroup.members?.find(m => Number(m.user_id) === Number(currentGroup.creator_id));
              const creatorName = storedMember?.user_name || 'Unknown User';
              console.log("👥 Adding creator manually (not found in usersList), name:", creatorName);
              return {
                user_id: Number(currentGroup.creator_id),
                user_name: creatorName,
                email: "",
                family_office_flag: true,
                isAdmin: true
              };
            }
            return null;
          }).filter(u => u !== null);

        } else {
          // For forum groups: Use existing forum API
          console.log(" Fetching users from forum API");
          const response = await axios.get(`/get_users_by_forum_with_office`, {
            params: {
              forum_id: this.activeConversation.id,
              entity_id: this.entity_id
            }
          });
          users = response.data.data || [];
        }

        console.log("👥 Fetched users from API:", users.length);

        if (users.length === 0 && currentGroup?.is_custom_group) {
          //  No members from API for custom group - show at least current user
          console.log(" No members returned from API for custom group");
          const currentUser = this.usersList.find(u => Number(u.id) === Number(this.logged_user_id));
          const userName = currentUser ? currentUser.user_name.replace(' (You)', '') : 'You';
          this.groupMembers = [{
            name: userName,
            position: currentUser?.designation || currentUser?.email || "",
            user_id: Number(this.logged_user_id),
            isYou: true
          }];
        } else {
          // Deduplicate and map to display format
          //  IMPORTANT: Only include users with family_office_flag: true
          const uniqueMembers = new Map();

          users.forEach(user => {
            //  Filter: Only include Family Office members
            if (user.family_office_flag !== true) {
              console.log(` Skipping ${user.user_name} (not Family Office member)`);
              return;
            }

            if (user.user_id && !uniqueMembers.has(user.user_id)) {
              uniqueMembers.set(user.user_id, {
                name: user.user_name || user.name || "Unknown",
                position: user.designation || user.position || "",
                user_id: user.user_id,
                isYou: user.user_id == this.logged_user_id,
                isAdmin: user.isAdmin || (currentGroup && currentGroup.creator_id && Number(user.user_id) === Number(currentGroup.creator_id))
              });
            }
          });

          this.groupMembers = Array.from(uniqueMembers.values());
        }

        //  Ensure creator/admin is ALWAYS present in the final list
        if (currentGroup && currentGroup.creator_id) {
          const creatorInList = this.groupMembers.some(m => Number(m.user_id) === Number(currentGroup.creator_id));
          if (!creatorInList) {
            const creatorUser = this.usersList.find(u => Number(u.id) === Number(currentGroup.creator_id));
            const storedCreator = currentGroup.members?.find(m => Number(m.user_id) === Number(currentGroup.creator_id));
            const creatorName = creatorUser ? creatorUser.user_name.replace(' (You)', '') : (storedCreator?.user_name || 'Unknown User');
            console.log("👥 Creator missing from final list, adding:", creatorName);
            this.groupMembers.push({
              name: creatorName,
              position: creatorUser?.designation || creatorUser?.email || storedCreator?.email || "",
              user_id: Number(currentGroup.creator_id),
              isYou: Number(currentGroup.creator_id) === Number(this.logged_user_id),
              isAdmin: true
            });
          }
        }

        //  Sort: Admin first, then You, then others alphabetically
        this.groupMembers.sort((a, b) => {
          if (a.isAdmin && !b.isAdmin) return -1;
          if (!a.isAdmin && b.isAdmin) return 1;
          if (a.isYou && !b.isYou) return -1;
          if (!a.isYou && b.isYou) return 1;
          return (a.name || '').localeCompare(b.name || '');
        });

        console.log(` Displaying ${this.groupMembers.length} members`);

        // Show the dialog
        this.showMembersDialog = true;

      } catch (error) {
        console.error(" Error fetching group members:", error);
        console.error("Error details:", error.response?.data);

        //  Last resort fallback for custom groups
        const currentGroup = this.groupsList.find(g => g.id === this.activeConversation.id);
        if (currentGroup?.is_custom_group) {
          console.log(" API failed, showing minimal member info");
          const currentUser = this.usersList.find(u => Number(u.id) === Number(this.logged_user_id));
          const userName = currentUser ? currentUser.user_name.replace(' (You)', '') : 'Unknown';
          this.groupMembers = [{
            name: userName,
            position: "Member list temporarily unavailable",
            user_id: Number(this.logged_user_id),
            isYou: true
          }];
          this.showMembersDialog = true;
        } else {
          alert("Failed to load group members. " + (error.response?.data?.error || error.message));
        }
      }
    },
    // Open Add Member dialog
    openAddMemberDialog() {
      // Get current group members' user IDs
      const currentMemberIds = this.groupMembers.map(m => m.user_id);

      // Filter users list to exclude current members
      this.availableUsersForAdd = this.usersList.filter(user => {
        const notCurrentUser = user.id !== parseInt(this.logged_user_id);
        const notInGroup = !currentMemberIds.includes(user.id);
        return notCurrentUser && notInGroup;
      });

      this.selectedUsersToAdd = [];  // Clear previous selections
      this.memberSearchQuery = '';
      this.showAddMemberDialog = true;
    },
    // Toggle user selection (for multiple selection)
    toggleUserSelection(user) {
      const index = this.selectedUsersToAdd.findIndex(u => u.id === user.id);
      if (index > -1) {
        // User already selected, remove them
        this.selectedUsersToAdd.splice(index, 1);
      } else {
        // User not selected, add them
        this.selectedUsersToAdd.push(user);
      }
    },
    // Check if user is selected
    isUserSelected(user) {
      return this.selectedUsersToAdd.some(u => u.id === user.id);
    },
    // Add multiple members to group (API call)
    async addMembersToGroup() {
      if (this.selectedUsersToAdd.length === 0) return;

      this.addingMember = true;
      let successCount = 0;
      let failedCount = 0;

      try {
        // Add all selected members in parallel
        const addPromises = this.selectedUsersToAdd.map(user =>
          axios.post(
            `/chat_rooms/${this.activeConversation.id}/add_member`,
            {
              user_id: user.id,
              requesting_user_id: parseInt(this.logged_user_id),
              entity_id: this.entity_id
            }
          )
        );

        const results = await Promise.allSettled(addPromises);

        // Process results
        results.forEach((result, index) => {
          if (result.status === 'fulfilled' && (result.value.data.success || result.value.status === 200)) {
            const user = this.selectedUsersToAdd[index];
            successCount++;

            // Add member to local groupMembers list
            this.groupMembers.push({
              name: user.user_name,
              position: user.email || "",
              user_id: user.id,
              isYou: false,
              isAdmin: false
            });

            // Update members in groupsList
            const currentGroup = this.groupsList.find(g => g.id === this.activeConversation.id);
            if (currentGroup && currentGroup.members) {
              currentGroup.members.push({
                user_id: user.id,
                user_name: user.user_name,
                email: user.email,
                isYou: false
              });
            }
          } else {
            failedCount++;
          }
        });

        // Update member count once for all additions
        const newMemberCount = this.groupMembers.length;
        const currentGroup = this.groupsList.find(g => g.id === this.activeConversation.id);
        if (currentGroup) {
          this.$set(currentGroup, 'memberCount', newMemberCount);
        }

        // Update header member count
        if (this.activeConversation) {
          this.$set(this.activeConversation, 'memberCount', newMemberCount);
        }

        console.log(`✅ Added ${successCount} members successfully!`);
        console.log("📊 New member count:", newMemberCount);

        // Show system message in chat & snackbar
        if (successCount > 0) {
          const names = this.selectedUsersToAdd.slice(0, successCount).map(u => u.user_name).join(', ');
          const actionText = successCount === 1
            ? `You added ${names} to the group`
            : `You added ${successCount} members to the group`;

          this.addSystemMessage(actionText, 'mdi-account-plus', '#4CAF50');
          this.showGroupAction(actionText, 'mdi-account-plus', '#4CAF50');
        }

        // Show error if some failed
        if (failedCount > 0) {
          this.showGroupAction(
            `${failedCount} member${failedCount > 1 ? 's' : ''} could not be added`,
            'mdi-alert-circle',
            '#FF9800'
          );
        }

      } catch (error) {
        console.error("Error adding member:", error);
        this.showGroupAction(
          error.response?.data?.error || 'Failed to add members',
          'mdi-alert-circle',
          '#F44336'
        );
      } finally {
        this.showAddMemberDialog = false;
        this.selectedUsersToAdd = [];
        this.memberSearchQuery = '';
        this.availableUsersForAdd = [];
        this.addingMember = false;
      }
    },
    // Close Add Member dialog
    closeAddMemberDialog() {
      this.showAddMemberDialog = false;
      this.selectedUsersToAdd = [];  // Clear selected users array
      this.memberSearchQuery = '';
      this.availableUsersForAdd = [];
    },
    // Confirm remove member
    confirmRemoveMember(member) {
      console.log("🗑️ Opening remove confirmation for:", member.name);
      this.memberToRemove = member;
      this.showRemoveMemberDialog = true;
    },
    // Remove member from group (API call)
    async removeMemberFromGroup() {
      if (!this.memberToRemove) return;

      this.removingMember = true;

      try {
        const response = await axios.delete(
          `/chat_rooms/${this.activeConversation.id}/remove_member`,
          {
            data: {
              user_id: this.memberToRemove.user_id,
              requesting_user_id: parseInt(this.logged_user_id)
            }
          }
        );

        if (response.data.success === true || response.status === 200) {
          // Remove member from local groupMembers list
          const index = this.groupMembers.findIndex(m => m.user_id === this.memberToRemove.user_id);
          if (index !== -1) {
            this.groupMembers.splice(index, 1);
          }

          // Update members in groupsList and header
          const newCount = this.groupMembers.length;
          const currentGroup = this.groupsList.find(g => g.id === this.activeConversation.id);
          if (currentGroup) {
            if (currentGroup.members) {
              const memberIndex = currentGroup.members.findIndex(m => m.user_id === this.memberToRemove.user_id);
              if (memberIndex !== -1) {
                currentGroup.members.splice(memberIndex, 1);
              }
            }
            this.$set(currentGroup, 'memberCount', newCount);
          }

          // Update header member count
          if (this.activeConversation) {
            this.$set(this.activeConversation, 'memberCount', newCount);
          }

          // Show system message in chat & snackbar
          const removedName = this.memberToRemove.name;
          this.addSystemMessage(`You removed ${removedName} from the group`, 'mdi-account-minus', '#F44336');
          this.showGroupAction(`You removed ${removedName} from the group`, 'mdi-account-minus', '#F44336');
        }
      } catch (error) {
        console.error("Error removing member:", error);
        this.showGroupAction(
          error.response?.data?.error || 'Failed to remove member',
          'mdi-alert-circle',
          '#F44336'
        );
      } finally {
        this.showRemoveMemberDialog = false;
        this.memberToRemove = null;
        this.removingMember = false;
      }
    },
    // Close Remove Member dialog
    closeRemoveMemberDialog() {
      this.showRemoveMemberDialog = false;
      this.memberToRemove = null;
    },
    // Confirm exit group
    confirmExitGroup() {
      this.showExitGroupDialog = true;
    },
    // Exit group (API call)
    async exitGroup() {
      this.exitingGroup = true;

      try {
        const response = await axios.post(
          `/chat_rooms/${this.activeConversation.id}/exit`,
          {
            user_id: parseInt(this.logged_user_id)
          }
        );

        console.log(" Exit group response:", response.data);

        if (response.data.success === true || response.status === 200) {
          // Remove group from groupsList
          const groupIndex = this.groupsList.findIndex(g => g.id === this.activeConversation.id);
          if (groupIndex !== -1) {
            this.groupsList.splice(groupIndex, 1);
          }

          // Close dialogs and clear active conversation
          this.showMembersDialog = false;
          this.showExitGroupDialog = false;
          this.activeConversation = null;

          this.showGroupAction(
            'You left the group',
            'mdi-exit-run',
            '#2196F3'
          );
        }
      } catch (error) {
        console.error("Error exiting group:", error);
        this.showGroupAction(
          error.response?.data?.error || 'Failed to exit group',
          'mdi-alert-circle',
          '#F44336'
        );
      } finally {
        this.exitingGroup = false;
      }
    },
    // Close Exit Group dialog
    closeExitGroupDialog() {
      this.showExitGroupDialog = false;
    },
    // Confirm delete group
    confirmDeleteGroup() {
      this.showDeleteGroupDialog = true;
    },
    // Delete group (API call - Admin only)
    async deleteGroup() {
      this.deletingGroup = true;

      try {
        const response = await axios.delete(
          `/chat_rooms/${this.activeConversation.id}/delete_group`,
          {
            params: {
              user_id: parseInt(this.logged_user_id)
            }
          }
        );

        console.log("Delete group response:", response.data);

        if (response.data.success === true || response.status === 200) {
          // Remove group from groupsList
          const groupIndex = this.groupsList.findIndex(g => g.id === this.activeConversation.id);
          if (groupIndex !== -1) {
            this.groupsList.splice(groupIndex, 1);
          }

          // Close all dialogs and clear active conversation
          this.showMembersDialog = false;
          this.showDeleteGroupDialog = false;
          this.activeConversation = null;

          this.showGroupAction(
            'Group has been deleted successfully',
            'mdi-delete',
            '#F44336'
          );
        }
      } catch (error) {
        console.error("Error deleting group:", error);
        this.showGroupAction(
          error.response?.data?.error || 'Failed to delete group',
          'mdi-alert-circle',
          '#F44336'
        );
      } finally {
        this.deletingGroup = false;
      }
    },
    // Close Delete Group dialog
    closeDeleteGroupDialog() {
      this.showDeleteGroupDialog = false;
    },
    // Confirm make admin
    confirmMakeAdmin(member) {
      console.log("👑 Opening make admin confirmation for:", member.name);
      this.memberToPromote = member;
      this.showMakeAdminDialog = true;
    },
    // Make member admin (API call - Admin only)
    async makeAdmin() {
      if (!this.memberToPromote) return;

      this.makingAdmin = true;

      try {
        const response = await axios.post(
          `/chat_rooms/${this.activeConversation.id}/make_admin`,
          {
            user_id: this.memberToPromote.user_id,
            requesting_user_id: parseInt(this.logged_user_id),
            entity_id: this.entity_id
          }
        );

        console.log("👑 Make admin response:", response.data);

        if (response.data.success === true || response.status === 200) {
          const promotedName = this.memberToPromote.name;

          // Update local group data - change creator_id
          const currentGroup = this.groupsList.find(g => g.id === this.activeConversation.id);
          if (currentGroup) {
            this.$set(currentGroup, 'creator_id', this.memberToPromote.user_id);
          }

          // Update isAdmin flags in groupMembers
          this.groupMembers.forEach(member => {
            if (member.user_id === this.memberToPromote.user_id) {
              this.$set(member, 'isAdmin', true);
            } else if (member.user_id == this.logged_user_id) {
              this.$set(member, 'isAdmin', false);
            }
          });

          // Re-sort members (Admin first, then You, then others)
          this.groupMembers.sort((a, b) => {
            if (a.isAdmin && !b.isAdmin) return -1;
            if (!a.isAdmin && b.isAdmin) return 1;
            if (a.isYou && !b.isYou) return -1;
            if (!a.isYou && b.isYou) return 1;
            return (a.name || '').localeCompare(b.name || '');
          });

          // Close dialog
          this.showMakeAdminDialog = false;
          this.memberToPromote = null;

          // Show system message in chat & snackbar
          this.addSystemMessage(
            `You made ${promotedName} the new admin`,
            'mdi-shield-crown',
            '#4CAF50'
          );
          this.showGroupAction(
            `${promotedName} is now the admin`,
            'mdi-shield-crown',
            '#4CAF50'
          );

          console.log("✅ Admin transferred successfully!");
        }
      } catch (error) {
        console.error("❌ Error making admin:", error);
        this.showGroupAction(
          error.response?.data?.error || 'Failed to make admin',
          'mdi-alert-circle',
          '#F44336'
        );
      } finally {
        this.makingAdmin = false;
      }
    },
    // Close Make Admin dialog
    closeMakeAdminDialog() {
      this.showMakeAdminDialog = false;
      this.memberToPromote = null;
    },
    // Show inline system message in chat (like WhatsApp/Teams)
    addSystemMessage(text, icon, color) {
      if (!this.activeConversation) return;
      const roomId = this.activeConversation.id;
      if (!this.messages[roomId]) {
        this.$set(this.messages, roomId, []);
      }
      this.messages[roomId].push({
        id: `sys_${Date.now()}`,
        text: text,
        is_system: true,
        systemIcon: icon,
        systemColor: color,
        timestamp: new Date().toISOString()
      });
      // Auto-scroll to bottom
      this.$nextTick(() => {
        const area = this.$refs.messagesArea;
        if (area) area.scrollTop = area.scrollHeight;
      });
    },
    // Show sleek snackbar notification for group actions
    showGroupAction(text, icon, color) {
      this.groupActionText = text;
      this.groupActionIcon = icon;
      this.groupActionColor = color;
      this.groupActionSnackbar = true;
    },
    // Open one-to-one chat with a group member
    openOneToOneChatFromGroup(member) {
      // Close the Group Members dialog
      this.showMembersDialog = false;

      // Switch to "All" tab (private chats)
      this.activeTab = 0;

      // Check if this user already exists in usersList
      let existingUser = this.usersList.find(u => u.id === member.user_id);

      if (existingUser) {
        // User already in list, just select the conversation
        this.selectConversation(existingUser);
      } else {
        // Create a new user object and add to usersList
        const newUser = {
          id: member.user_id,
          user_name: member.name,
          position: member.position,
          lastMessage: null,
          unreadCount: 0
        };

        // Add to the beginning of usersList
        this.usersList.unshift(newUser);

        // Select the conversation
        this.selectConversation(newUser);
      }
    },
    // Group Creation Methods
    openCreateGroupDialog() {
      this.newGroupName = '';
      this.selectedMembers = [];
      this.memberSearchQuery = '';
      this.showCreateGroupDialog = true;
    },
    closeCreateGroupDialog() {
      this.showCreateGroupDialog = false;
      this.newGroupName = '';
      this.selectedMembers = [];
    },
    proceedToMemberSelection() {
      if (!this.newGroupName || this.newGroupName.trim() === '') {
        alert('Please enter a group name');
        return;
      }

      this.showCreateGroupDialog = false;
      this.showSelectMembersDialog = true;
    },
    closeSelectMembersDialog() {
      this.showSelectMembersDialog = false;
      this.selectedMembers = [];
      this.memberSearchQuery = '';
    },
    backToGroupName() {
      this.showSelectMembersDialog = false;
      this.showCreateGroupDialog = true;
    },
    toggleMemberSelection(user) {
      const index = this.selectedMembers.findIndex(m => m.id === user.id);
      if (index > -1) {
        // Remove user
        this.selectedMembers.splice(index, 1);
      } else {
        // Add user
        this.selectedMembers.push(user);
      }
    },
    isUserSelected(userId) {
      return this.selectedMembers.some(m => m.id === userId);
    },
    async createGroup() {
      if (this.selectedMembers.length === 0) {
        alert('Please select at least one member');
        return;
      }

      if (!this.newGroupName || this.newGroupName.trim() === '') {
        alert('Please enter a group name');
        return;
      }

      this.creatingGroup = true;

      try {
        // Collect participant IDs (selected members only, user_id will be added separately)
        const participantIds = this.selectedMembers.map(m => m.id);

        console.log(" Creating group:", this.newGroupName);
        console.log(" Participants:", participantIds);

        // Call the group chat room API
        const response = await axios.post('/group_chat_room_details', {
          participant_ids: participantIds,
          user_id: parseInt(this.logged_user_id),
          entity_id: parseInt(this.entity_id),
          group_name: this.newGroupName.trim(),
          forum_id: null  // Set to null for non-forum groups, or use actual forum_id if available
        });

        if (response.data && response.data.room_id) {
          const roomId = response.data.room_id;
          const groupName = this.newGroupName.trim();

          console.log(" Group created successfully with room_id:", roomId);

          // Close dialogs
          this.showSelectMembersDialog = false;
          this.showCreateGroupDialog = false;

          // Save group name for success message before clearing
          const createdGroupName = groupName;

          //  Store member details for later retrieval
          const groupMembers = [
            // Add current user
            {
              user_id: parseInt(this.logged_user_id),
              user_name: this.usersList.find(u => u.id == this.logged_user_id)?.user_name?.replace(' (You)', '') || "You",
              isYou: true
            },
            // Add selected members
            ...this.selectedMembers.map(m => ({
              user_id: m.id,
              user_name: m.user_name,
              email: m.email,
              isYou: false
            }))
          ];

          //  Manually add the newly created group to groupsList
          const newGroup = {
            id: roomId,
            group_name: createdGroupName,
            memberCount: this.selectedMembers.length + 1, // +1 for current user
            lastMessage: null,
            unreadCount: 0,
            room_id: roomId,
            is_custom_group: true,
            creator_id: parseInt(this.logged_user_id),  // Store creator/admin ID
            members: groupMembers  //  Store members with the group
          };

          // Add to beginning of groups list - use array spread to ensure Vue reactivity
          this.groupsList = [newGroup, ...this.groupsList];
          console.log(" Added new group to groupsList. Total groups:", this.groupsList.length);

          // Clear form
          this.newGroupName = '';
          const selectedMembersCount = this.selectedMembers.length;
          this.selectedMembers = [];
          this.memberSearchQuery = '';

          // Switch to groups tab
          this.activeTab = 1;

          // Show success message
          this.$toast.add({
            severity: 'success',
            summary: 'Success',
            detail: `Group "${createdGroupName}" created successfully!`,
            life: 3000
          });

          //  Automatically open the newly created group
          try {
            await this.selectGroup(newGroup);
            console.log(" Group added to list and opened successfully!");
          } catch (selectError) {
            console.error(" Group created but failed to open:", selectError);
            // Group is already created and added to list, just show a warning
            alert("Group created successfully, but couldn't open it automatically. Please click on it from the list.");
          }

        } else {
          throw new Error('Invalid response from server');
        }

      } catch (error) {
        console.error("❌ Error creating group:", error);

        // Show error toast
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to create group. Please try again.',
          life: 3000
        });
      } finally {
        this.creatingGroup = false;
      }
    }
  }
};
</script>

<style>
/* Global styles to hide toggle buttons from ANY parent component */
.chat-wrapper .v-btn[class*="light-mode"],
.chat-wrapper .v-btn[class*="theme-toggle"],
.chat-wrapper .v-btn[class*="mode-toggle"],
.chat-wrapper button[class*="toggle"],
body .v-btn.theme-toggle,
body .v-btn.light-mode-toggle,
body .v-btn.mode-toggle-btn,
body button.theme-toggle,
body button.light-mode-toggle {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  z-index: -9999 !important;
}

/* Ensure v-menu content appears above chat drawer (z-index: 10000) */
.v-menu__content {
  z-index: 20000 !important;
}
</style>

<style scoped>
/* Hide any floating toggle buttons from parent components */
::v-deep .v-btn[class*="light-mode"],
::v-deep .v-btn[class*="theme-toggle"],
::v-deep .v-btn[class*="mode-toggle"],
::v-deep .v-btn[class*="toggle"],
::v-deep button[class*="light-mode"],
::v-deep button[class*="theme-toggle"],
::v-deep button[class*="mode-toggle"],
::v-deep .theme-toggle,
::v-deep .light-mode-toggle,
::v-deep .mode-toggle-btn {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Hide any fixed/absolute positioned buttons that might be floating */
::v-deep .v-btn[style*="position: fixed"],
::v-deep .v-btn[style*="position: absolute"] {
  display: none !important;
}

/* ========================================
   CUSTOM SCROLLBAR STYLING (Elegant & Clean)
   ======================================== */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  transition: background 0.3s ease;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.25);
}

/* Firefox */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
}

/* Smooth scrolling */
.custom-scrollbar {
  scroll-behavior: smooth;
}

/* Main chat wrapper */
.chat-wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.chat-area {
  margin-left: 35%;
  width: 50%;
  height: calc(100vh - 80px);
  /* Full screen height minus header */
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
  overflow: hidden;
  position: relative;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* Header (fixed at top) */
.chat-header {
  background: linear-gradient(135deg, #26c6da, #00acc1);
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  /* z-index: 10; */
  flex-shrink: 0;
  height: 56px;
}

/* Messages area (scrollable) */
.messages-area {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  /* optional: aligns messages at bottom */
}

/* Custom scrollbar for messages area */
.messages-area::-webkit-scrollbar {
  width: 6px;
}

.messages-area::-webkit-scrollbar-track {
  background: transparent;
}

.messages-area::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

.messages-area::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.25);
}

/* Chat bubbles */
.chat-bubble {
  display: inline-block;
  max-width: 65%;
  padding: 10px 14px;
  border-radius: 18px;
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 14px;
  line-height: 1.4;
  position: relative;
  margin: 4px 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.2s ease-in-out;
}

/* Sender (Right side) */
.sender {
  align-self: flex-end;
  background: linear-gradient(135deg, #4dd0e1, #00897b);
  color: white;
  border-bottom-right-radius: 4px;
}

/* Receiver (Left side) */
.receiver {
  align-self: flex-start;
  background: linear-gradient(135deg, #ffe0b2, #ffb74d);
  color: #4e342e;
  border-bottom-left-radius: 4px;
}

/* Small tails for chat bubbles */
.sender::after,
.receiver::after {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0;
  height: 0;
}

.sender::after {
  right: -8px;
  border-left: 8px solid #00897b;
  border-top: 8px solid transparent;
  border-bottom: 0 solid transparent;
}

.receiver::after {
  left: -8px;
  border-right: 8px solid #ffb74d;
  border-top: 8px solid transparent;
  border-bottom: 0 solid transparent;
}

/* Smooth fade-in for new messages */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Timestamp styling */
.chat-bubble+small {
  font-size: 11px;
  opacity: 0.7;
  margin-top: 2px;
}

/* Group sender row: avatar + name above receiver bubble */
.group-sender-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 3px;
}

.group-msg-avatar {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid rgba(0,0,0,0.1);
}

.group-msg-avatar-initial {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7b5ea7, #4dd0e1);
  color: white;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.group-sender-name {
  font-size: 11px;
  font-weight: 600;
  color: #7b5ea7;
}

/* Seen-by row (below my own group messages) */
.seen-by-row {
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 2px;
  padding-right: 2px;
}

.seen-by-names {
  font-size: 10px;
  color: #1565c0;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* System message (WhatsApp/Teams style) */
.system-message-wrapper {
  display: flex;
  justify-content: center;
  margin: 8px 0;
}

.system-message {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #e8f5e9, #f3e5f5);
  color: #455a64;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 20px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  letter-spacing: 0.2px;
  max-width: 80%;
  text-align: center;
}

/* Group action snackbar */
.group-action-snackbar .v-snack__wrapper {
  border-radius: 24px !important;
  min-width: auto !important;
  padding: 2px 8px !important;
}

.message-timestamp {
  font-size: 11px !important;
  opacity: 0.7;
  margin-top: 4px;
  padding: 0 4px;
}

.align-self-end {
  align-self: flex-end;
  text-align: right;
}

.align-self-start {
  align-self: flex-start;
  text-align: left;
}


/* Input area (fixed at bottom of chat container) */
.chat-input-area {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #e0f7fa;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  gap: 8px;
  position: relative;
  z-index: 10;
  margin-bottom: 0;
}

.message-input {
  border-radius: 24px !important;
  flex: 1;
  margin: 0 !important;
  padding: 0 !important;
}

::v-deep .message-input .v-input__slot {
  background: white !important;
  border-radius: 24px !important;
  min-height: 44px !important;
  padding: 0 16px !important;
}

::v-deep .message-input fieldset {
  border-color: rgba(0, 0, 0, 0.15) !important;
  border-radius: 24px !important;
}

::v-deep .message-input.v-input--is-focused fieldset {
  border-color: #26c6da !important;
  border-width: 2px !important;
}

::v-deep .message-input input {
  color: #333 !important;
  caret-color: #26c6da !important;
}

::v-deep .message-input input::placeholder {
  color: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .message-input .v-text-field__details {
  display: none !important;
}

.send-btn {
  background: linear-gradient(135deg, #26c6da, #00acc1) !important;
  color: white !important;
  border-radius: 50%;
  margin-left: 4px;
  width: 44px !important;
  height: 44px !important;
  min-width: 44px !important;
  transition: all 0.3s ease;
}

::v-deep .send-btn .v-icon {
  color: white !important;
}

.send-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 16px rgba(38, 198, 218, 0.5);
}

.chat-container-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 56px;
  background: linear-gradient(135deg, #26c6da, #00acc1);
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: indigo;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-weight: bold;
  color: white;
}

.avatar.group-avatar {
  background: linear-gradient(135deg, #667eea, #764ba2);
}

.user-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 2px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  /* spacing between status and close button */
}

.user-status {
  font-size: 12px;
  color: #e0f7fa;
}

.close-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
}

.close-btn:hover {
  color: #ffeb3b;
}

.fancy-drawer-light {
  background: linear-gradient(135deg, #fdfbfb, #ebedee);
  border-left: 2px solid #f0f0f0;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.08);
}

.drawer-header-light {
  background: linear-gradient(90deg, #a18cd1, #fbc2eb);
  color: #fff !important;
}

.close-btn {
  background: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  backdrop-filter: blur(6px);
}

.sub-header-light {
  background: #ffffff;
  border-bottom: 1px solid #eee;
  color: #7b7b7b;
}

.search-bar {
  background: #ffffff !important;
  border-radius: 12px;
}

.avatar-gradient {
  background: linear-gradient(135deg, #ff9a9e, #fad0c4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-gradient-group {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Group Members Dialog Avatar */
.group-member-avatar {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.group-member-avatar span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 18px;
}

/* Clickable member in Group Members dialog */
.clickable-member {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.clickable-member:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

/* Select Members Dialog Avatar */
.select-member-avatar {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.select-member-avatar span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 18px;
}

.conversation-list {
  max-height: calc(100vh - 260px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 8px;
  padding-top: 4px;
}

/* Apply custom scrollbar to conversation list */
.conversation-list::-webkit-scrollbar {
  width: 5px;
}

.conversation-list::-webkit-scrollbar-track {
  background: transparent;
}

.conversation-list::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.conversation-list::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}

.conversation-item-light {
  border-radius: 14px;
  margin: 4px 12px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.6);
}

.conversation-item-light:hover {
  background: linear-gradient(90deg, rgba(255, 182, 193, 0.2), rgba(173, 216, 230, 0.2));
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.emoji-picker {
  max-width: 250px;
  max-height: 200px;
  overflow-y: auto;
}

.emoji-item {
  font-size: 20px;
  padding: 5px;
  cursor: pointer;
}

.emoji-item:hover {
  background: #f0f0f0;
  border-radius: 6px;
}

/* Voice recording styles */
.recording-indicator {
  background: rgba(255, 82, 82, 0.1);
  padding: 8px 12px;
  border-radius: 24px;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.recording-pulse {
  animation: recordPulse 1s ease-in-out infinite;
}

@keyframes recordPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}

/* Voice message styles */
.voice-message {
  min-width: 200px;
}

.voice-waveform {
  flex: 1;
  height: 20px;
  background: repeating-linear-gradient(
    90deg,
    currentColor 0px,
    currentColor 2px,
    transparent 2px,
    transparent 6px
  );
  border-radius: 4px;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.voice-waveform.playing {
  opacity: 1;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

/* Attachment menu styles */
.attachment-menu {
  border-radius: 12px;
  overflow: hidden;
  min-width: 280px;
}

.attachment-item {
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 12px 16px;
}

.attachment-item:hover {
  background: rgba(0, 0, 0, 0.04);
  transform: translateX(4px);
}

.attachment-icon {
  width: 48px !important;
  height: 48px !important;
  min-width: 48px !important;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-right: 12px;
}

.attachment-icon .v-icon {
  font-size: 24px;
}

/* Smooth slide-in animation for attachment menu */
.v-menu__content {
  animation: slideUp 0.3s ease-out;
  z-index: 20000 !important;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* File attachment styles */
.file-attachment {
  max-width: 100%;
}

.image-attachment {
  max-width: 300px;
}

.attachment-image {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
}

.attachment-image:hover {
  transform: scale(1.02);
}

.video-attachment {
  max-width: 300px;
}

.attachment-video {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
}

.document-attachment {
  min-width: 250px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.file-name {
  word-break: break-word;
  max-width: 250px;
}

/* Make sender file attachments have white text */
.sender .file-name,
.sender .caption {
  color: white !important;
}

/* Make receiver file attachments have dark text */
.receiver .file-name,
.receiver .caption {
  color: #4e342e !important;
}

/* File preview styles */
.file-preview-container {
  background: #f5f5f5;
  border-radius: 8px;
  max-height: 200px;
}

.file-preview-list {
  overflow-x: auto;
  overflow-y: hidden;
}

.file-preview-item {
  position: relative;
}

.preview-image-wrapper,
.preview-video-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-document {
  position: relative;
  width: 80px;
  padding: 8px;
  background: white;
  border-radius: 8px;
  text-align: center;
}

.remove-file-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.6) !important;
}

.remove-file-btn:hover {
  background: rgba(255, 0, 0, 0.8) !important;
}

/* Delete message button */
.message-wrapper {
  position: relative;
}

.delete-message-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  opacity: 0;
  transition: opacity 0.2s;
  background: white !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.message-wrapper:hover .delete-message-btn {
  opacity: 1;
}

.delete-message-btn:hover {
  background: #ffebee !important;
}

/* Groups member count chip */
.member-count-chip {
  font-weight: bold;
  font-size: 12px;
  min-width: 40px;
  justify-content: center;
}

/* Selected member item in group creation */
.selected-member-item {
  background: rgba(25, 118, 210, 0.08) !important;
  border-left: 3px solid #1976d2;
}

.selected-member-item:hover {
  background: rgba(25, 118, 210, 0.12) !important;
}

/* Clickable member count in header */
.member-count-clickable {
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  line-height: 1.3;
  margin-top: 2px;
  display: inline-block;
}

.member-count-clickable:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

/* ========================================
   ADMIN ACTION BUTTONS - Professional Styling
   ======================================== */
.admin-action-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.admin-action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.admin-action-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Make Admin Dialog - Professional Styling */
.make-admin-dialog .v-card__title {
  border-radius: 4px 4px 0 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.make-admin-dialog .v-avatar {
  border: 3px solid #4CAF50;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease;
}

.make-admin-dialog .v-avatar:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
}

/* Smooth fade-in animation for dialogs */
@keyframes fadeInDialog {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.make-admin-dialog {
  animation: fadeInDialog 0.3s ease-out;
}

/* Enhanced button styles */
.make-admin-dialog .v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.make-admin-dialog .v-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
</style>
